
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iNq0h", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $c1632a1d98dd95be$export$c947bf9ea37af41f = (0, $eSUdr.default)`query HomeViewsUserPreferencesQuery{userPreferences{homePagesDisplayView}}`;
const $c1632a1d98dd95be$export$3563be99821d5f00 = (0, $eSUdr.default)`mutation HomeViewsUserPreferencesMutation($appearance:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{homePagesDisplayView:$appearance}){homePagesDisplayView}}`;
module.exports["HomeViewsUserPreferencesQuery"] = $c1632a1d98dd95be$export$c947bf9ea37af41f;

});

parcelRegister("AXitC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7tW57 = parcelRequire("7tW57");

const $e95f65381b50496d$export$ab112bfcbe68934f = (0, $42omo.createContext)({
    id: '',
    title: {
        text: '',
        emoji: ''
    },
    type: 'page',
    subType: null,
    status: undefined,
    createdBy: {
        displayName: '',
        profilePicture: '',
        accountId: ''
    },
    ownedBy: {
        displayName: '',
        profilePicture: '',
        accountId: ''
    },
    space: {
        spaceKey: '',
        name: ''
    },
    lastAction: {
        when: '',
        action: 'visited'
    },
    editorVersion: '',
    isStarred: false,
    links: {
        webui: '',
        editui: ''
    },
    history: {
        ownedBy: {
            displayName: ''
        }
    },
    creatorId: '',
    likesCount: 0,
    commentsCount: 0,
    setIsMenuOpen: ()=>{},
    isMenuOpen: false,
    setSelectedMenuItems: ()=>{},
    selectedMenuItems: {
        [(0, $7tW57.QuickActionsEnum).ShareButton]: false,
        [(0, $7tW57.QuickActionsEnum).WatchButton]: false
    },
    appearance: 'grid',
    isViewed: false,
    setIsViewed: ()=>{},
    smallCard: false
});
module.exports["PageCardContext"] = $e95f65381b50496d$export$ab112bfcbe68934f;

});

parcelRegister("dDr80", function(module, exports) {
/* PageCardContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dYA5q = parcelRequire("dYA5q");


var $AXitC = parcelRequire("AXitC");

const $e6de9c0e17433620$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMenuOpen: isMenuOpen, isFolderHoverCard: isFolderHoverCard, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rko1mok _kqswh2mm _bfhkvuon",
            __cmplp.isMenuOpen ? "_14iykb7n" : "_14iyidpf",
            !__cmplp.isFolderHoverCard && "_1qamtlke _1pjhtlke _d0altlke _17zqt94y _km9nt94y _1soat94y _180dt7xp _1u6lt7xp _1dbzt7xp",
            __cmplp.className
        ])
    });
});
const $e6de9c0e17433620$export$70b207c5186d7ade = ({ StyledCard: StyledCard = $e6de9c0e17433620$export$60332b2344f7fe41, children: children, isHoverPageCard: isHoverPageCard, isListitem: isListitem, onClick: onClick })=>{
    const { isMenuOpen: isMenuOpen, setIsViewed: setIsViewed, type: type, subType: subType, status: status } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const styledCardRef = (0, $42omo.useRef)(null);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsViewed(true);
    }, [
        setIsViewed
    ]);
    const isFolderHoverCard = isHoverPageCard && type === 'folder';
    const isLivePage = subType === 'live' && status !== 'archived';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(StyledCard, {
        ref: styledCardRef,
        isMenuOpen: isMenuOpen,
        onMouseEnter: handleMouseEnter,
        onFocus: handleMouseEnter,
        isFolderHoverCard: isFolderHoverCard,
        onClick: (e)=>{
            onClick?.();
            isFolderHoverCard && e.stopPropagation();
        },
        "data-testid": "page-card-card-container",
        role: isListitem ? 'listitem' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYA5q.LivePagePreloader), {
        isLivePage: isLivePage
    }, children));
};
module.exports["Card"] = $e6de9c0e17433620$export$60332b2344f7fe41;
module.exports["PageCardContainer"] = $e6de9c0e17433620$export$70b207c5186d7ade;

});

parcelRegister("aoeyL", function(module, exports) {
/* ContentIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $bCECL = parcelRequire("bCECL");


var $brn6e = parcelRequire("brn6e");


var $2JGYp = parcelRequire("2JGYp");


var $di8q4 = parcelRequire("di8q4");


var $gz8ZY = parcelRequire("gz8ZY");


var $9wGTI = parcelRequire("9wGTI");


var $7uUnJ = parcelRequire("7uUnJ");


var $AXitC = parcelRequire("AXitC");

const $293a049c82938ad0$var$i18n = (0, $cgtv4.defineMessages)({
    livePage: {
        id: "page-card.live.page.label",
        defaultMessage: "Live doc"
    },
    page: {
        id: "page-card.page.label",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "page-card.blog.label",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "page-card.whiteboard.label",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "page-card.database.label",
        defaultMessage: "Database"
    },
    folder: {
        id: "page-card.folder.label",
        defaultMessage: "Folder"
    }
});
//the & div styles fix the emoji loader grey square
//the & span fixes the negative margin in the ak component chopping off the bottom of the emoji
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $293a049c82938ad0$var$EmojiContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.compact ? "_1reo15vq _18m915vq _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _172pidpf _1hcdidpf _1oyyidpf _19h8idpf _1b941ule" : "_4t3i1ou6 _1bsb1ou6 _1wyb1ou6",
            __cmplp.className
        ])
    });
});
const $293a049c82938ad0$var$EmojiWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8nf1z _1e0c1txw _1bah1h6o _p12f1f4h _1bsb1f4h _u5f312x7 _ca0qv77o _n3tdv77o _80om1wug",
            __cmplp.className
        ])
    });
});
const $293a049c82938ad0$var$iconBorderStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    height: '32px',
    width: '32px'
});
const $293a049c82938ad0$export$a1ea799cb5c1b499 = ({ wrapper: wrapper })=>{
    const { type: type, title: { emoji: emoji }, appearance: appearance, subType: subType } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const intl = (0, $8C5kA.default)();
    const compact = appearance === 'compact-list';
    const Wrapper = wrapper || $293a049c82938ad0$var$EmojiWrapper;
    const isLivePage = subType === 'live';
    const isCompactEndOfPage = appearance === 'compact-end-of-page';
    if (isNav4Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            !isCompactEndOfPage && $293a049c82938ad0$var$iconBorderStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: type,
        emoji: emoji,
        subType: subType
    }));
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($293a049c82938ad0$var$EmojiContainer, {
        compact: compact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji,
        contentType: type,
        height: compact ? 16 : 26,
        context: "pageCard",
        wrapper: Wrapper
    }));
     // Handle emoji expresion test
    if ((0, $brn6e.emojiExp).test(emoji)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($293a049c82938ad0$var$EmojiContainer, {
        compact: compact
    }, emoji);
    if (isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7uUnJ.LiveDocsIconTile), {
        label: intl.formatMessage($293a049c82938ad0$var$i18n.livePage),
        size: compact ? 'small' : 'medium',
        testId: "live-docs-icon-tile"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
        type: type,
        subType: subType,
        height: compact ? 16 : 26
    });
};
module.exports["ContentIcon"] = $293a049c82938ad0$export$a1ea799cb5c1b499;

});

parcelRegister("9CEYG", function(module, exports) {
/* PageLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");


var $jlIaF = parcelRequire("jlIaF");


var $56QzY = parcelRequire("56QzY");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $AXitC = parcelRequire("AXitC");


var $jsaQN = parcelRequire("jsaQN");


var $cxMI6 = parcelRequire("cxMI6");

const $ba0d74007085c540$var$PageLinkComponent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _154iidpf _1ltvidpf _syaz1j28 _1pbyidpf _rk8tkb7n",
            __cmplp.compact ? "_vn89n7od" : "_vn89bz73",
            __cmplp.className
        ])
    });
});
const $ba0d74007085c540$export$cf060141faaf6cdf = ({ compact: compact, shouldHideFolder: shouldHideFolder, featureAttributionCode: featureAttributionCode })=>{
    const context = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { id: id, type: type, status: status, title: { text: text }, links: { webui: webui } } = context;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((action, includeNavdex)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: (0, $cxMI6.isSpacePageCard)(context) ? 'spacePageCard' : 'globalPageCard',
                attributes: {
                    ...includeNavdex && {
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    },
                    contentType: type,
                    contentId: id,
                    contentStatus: status ?? null
                }
            }
        }).fire();
    }, [
        context,
        createAnalyticsEvent,
        id,
        type,
        status
    ]);
    const handlePageCardClick = (0, $42omo.useCallback)((e)=>{
        fireAnalyticsEvent('clicked', true);
        if (featureAttributionCode) {
            e.preventDefault();
            if (e.metaKey || e.ctrlKey) window.open((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(`${(0, $jlIaF.CONTEXT_PATH)}${webui}`, [
                featureAttributionCode
            ]));
            else push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(`${(0, $jlIaF.CONTEXT_PATH)}${webui}`, [
                featureAttributionCode
            ]));
        }
    }, [
        featureAttributionCode,
        fireAnalyticsEvent,
        push,
        webui
    ]);
    const handlePageCardHover = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        fireAnalyticsEvent('hovered', false);
    }, [
        fireAnalyticsEvent
    ]); // in the content tree, folders are buttons that expand/collapse the folder, and not links
    const shouldRenderLink = !shouldHideFolder || type !== 'folder';
    return shouldRenderLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ba0d74007085c540$var$PageLinkComponent, {
        href: `${(0, $jlIaF.CONTEXT_PATH)}${webui}`,
        onClick: handlePageCardClick,
        onMouseEnter: handlePageCardHover,
        compact: compact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, text)) : null;
};
module.exports["PageLink"] = $ba0d74007085c540$export$cf060141faaf6cdf;

});

parcelRegister("jsaQN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7QM6o = parcelRequire("7QM6o");


var $AXitC = parcelRequire("AXitC");

const $c6d4c54e6938616a$export$3acd67f057972c5d = ()=>{
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { id: id, ranking: ranking, analyticsData: analyticsData, appearance: appearance, type: type } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const spaceId = (0, $7QM6o.useSpaceId)();
    const createAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        payload.data.objectType = type;
        payload.data.objectId = payload.data.objectId ? payload.data.objectId : id;
        payload.data.containerType = 'space';
        payload.data.containerId = spaceId;
        if (appearance === 'popup-view') payload.data.actionSubjectId = 'pageTree';
        payload.data.source = payload.data.source ? payload.data.source : analyticsData?.source;
        payload.data.attributes = {
            ...payload.data.attributes,
            ...analyticsData?.attributes
        };
        if (typeof ranking === 'number') payload.data.attributes.ranking = ranking;
        payload.data.attributes.view = appearance;
        return akCreateAnalyticsEvent(payload);
    }, [
        id,
        spaceId,
        ranking,
        analyticsData,
        appearance,
        type,
        akCreateAnalyticsEvent
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
};
module.exports["usePageCardAnalyticsEvents"] = $c6d4c54e6938616a$export$3acd67f057972c5d;

});

parcelRegister("63k9q", function(module, exports) {
/* Title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gz8ZY = parcelRequire("gz8ZY");


var $AXitC = parcelRequire("AXitC");

'use no memo';
const $601474ee7590553b$var$baseStyle = null;
const $601474ee7590553b$var$defaultNav3Style = null;
const $601474ee7590553b$var$defaultStyle = null;
const $601474ee7590553b$var$singleLineStyle = null;
const $601474ee7590553b$var$appearanceTitleStylesNav3 = {
    grid: "",
    list: "",
    'compact-list': "_11c81ixg _k48p1wq8",
    'end-of-page': "_11c81vhk"
};
const $601474ee7590553b$var$appearanceTitleStyles = {
    grid: "_otyr1b66",
    list: "_11c82smr _k48pi7a9",
    'compact-list': "",
    'end-of-page': "_11c81vhk",
    'compact-end-of-page': "_11c81o8v"
};
const $601474ee7590553b$export$f99233281efd08a0 = ({ singleLine: singleLine, ariaLevelOverride: ariaLevelOverride })=>{
    const { id: id, title: { text: text }, appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: `content-title-${id}`,
        role: "heading",
        "aria-level": ariaLevelOverride ?? 2,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _12ji1r31 _1qu2glyw _12y31o36 _syazi7uo _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hi7uo _f8pji7uo _30l3i7uo _1053i7uo",
            isNav4Enabled ? "_11c8nbxd" : "_11c8lodh _k48pi7a9",
            isNav4Enabled ? $601474ee7590553b$var$appearanceTitleStyles[appearance] : $601474ee7590553b$var$appearanceTitleStylesNav3[appearance],
            singleLine && "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s"
        ])
    }, text);
};
module.exports["Title"] = $601474ee7590553b$export$f99233281efd08a0;

});

parcelRegister("kzTi3", function(module, exports) {
/* EndOfPageView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $71GjD = parcelRequire("71GjD");


var $AXitC = parcelRequire("AXitC");


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $9CEYG = parcelRequire("9CEYG");
/* RecommendationStrategy.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $bTdbD = parcelRequire("bTdbD");


var $3HOqx = parcelRequire("3HOqx");


var $226KS = parcelRequire("226KS");


var $1bY7o = parcelRequire("1bY7o");





var $c9Olr = parcelRequire("c9Olr");

const $8a88bacc20f8ad66$var$i18n = (0, $cgtv4.defineMessages)({
    BEHAVIORAL: {
        id: "page-card.rec.strategy.behavioral",
        defaultMessage: "Read with this"
    },
    CONTENT_TO_CONTENT: {
        id: "page-card.rec.strategy.content-to-content",
        defaultMessage: "More like this"
    },
    STRUCTURAL: {
        id: "page-card.rec.strategy.structural",
        defaultMessage: "Grouped with this"
    },
    LINKED_CONTENT: {
        id: "page-card.rec.strategy.linked-content",
        defaultMessage: "Linked from this"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8a88bacc20f8ad66$var$StrategyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1e0c1txw _4cvr1h6o _k48p1wq8 _syazazsu",
            __cmplp.className
        ])
    });
});
const $8a88bacc20f8ad66$var$StrategyText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _18u0u2gc _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $8a88bacc20f8ad66$var$Icons = {
    BEHAVIORAL: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }),
    CONTENT_TO_CONTENT: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    }),
    STRUCTURAL: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }),
    LINKED_CONTENT: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })
};
const $8a88bacc20f8ad66$export$96fa1e7da452e6c0 = ()=>{
    const { recommendationStrategy: recommendationStrategy } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const validRecommendationStrategies = [
        'STRUCTURAL',
        'BEHAVIORAL',
        'CONTENT_TO_CONTENT',
        'LINKED_CONTENT'
    ];
    const Icon = recommendationStrategy && validRecommendationStrategies.includes(recommendationStrategy) && $8a88bacc20f8ad66$var$Icons[recommendationStrategy];
    return recommendationStrategy && validRecommendationStrategies.includes(recommendationStrategy) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8a88bacc20f8ad66$var$StrategyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, Icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8a88bacc20f8ad66$var$StrategyText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8a88bacc20f8ad66$var$i18n[recommendationStrategy])))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null);
};


var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $defe7c171d25eb25$var$StyledCard = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $dDr80.Card), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _i0dl1osq _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$StyledCardWithHover = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $defe7c171d25eb25$var$StyledCard, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_irr3ufnl",
            __cmplp.className
        ])
    });
});
const $defe7c171d25eb25$var$GridCard = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41xcl _1e0c1txw _2lx21bp4 _1bsb1kdh _4t3i1pm2 _c71lgx0z",
            __cmplp.className
        ])
    });
});
const $defe7c171d25eb25$var$Header = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 'space.100'
});
const $defe7c171d25eb25$var$HeaderSmallCard = (0, $ecnYn.xcss)({
    marginBottom: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$IconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19pk1b66",
            __cmplp.className
        ])
    });
});
const $defe7c171d25eb25$var$TitlesContainer = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    overflowWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $defe7c171d25eb25$var$TitlesContainerSmallCard = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $defe7c171d25eb25$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81o8v _1e0ccj1k _1yyj11wp _sudp1e54",
            __cmplp.className
        ])
    });
});
const $defe7c171d25eb25$var$SubtitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81o8v _1e0c1txw _1pbyidpf",
            __cmplp.className
        ])
    });
});
const $defe7c171d25eb25$var$FooterContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _4cvresu3",
            __cmplp.className
        ])
    });
});
const $defe7c171d25eb25$var$FooterBigCard = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $defe7c171d25eb25$var$Footer = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $defe7c171d25eb25$export$6a5a043d6c50f30e = ({ showCardsAsListitem: showCardsAsListitem = true })=>{
    // ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
    const { smallCard: smallCard } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
        StyledCard: smallCard ? $defe7c171d25eb25$var$StyledCardWithHover : $defe7c171d25eb25$var$StyledCard,
        isListitem: showCardsAsListitem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
        featureAttributionCode: (0, $71GjD.FeatureCode).EOP_REC
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$GridCard, {
        "data-testid": "page-card-end-of-page-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $defe7c171d25eb25$var$Header,
            ...smallCard ? [
                $defe7c171d25eb25$var$HeaderSmallCard
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $defe7c171d25eb25$var$TitlesContainer,
            ...smallCard ? [
                $defe7c171d25eb25$var$TitlesContainerSmallCard
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
        ariaLevelOverride: 3
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$SubtitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($defe7c171d25eb25$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $defe7c171d25eb25$var$Footer,
            ...smallCard ? [] : [
                $defe7c171d25eb25$var$FooterBigCard
            ]
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8a88bacc20f8ad66$export$96fa1e7da452e6c0), null)))));
};
module.exports["EndOfPageView"] = $defe7c171d25eb25$export$6a5a043d6c50f30e;

});

parcelRegister("c9Olr", function(module, exports) {
/* LastAction.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $1Zr9M = parcelRequire("1Zr9M");


var $9FnLD = parcelRequire("9FnLD");


var $1yB28 = parcelRequire("1yB28");


var $kevJM = parcelRequire("kevJM");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $1YXTQ = parcelRequire("1YXTQ");


var $gz8ZY = parcelRequire("gz8ZY");


var $AXitC = parcelRequire("AXitC");

const $5445257a17f279b7$var$i18n = (0, $cgtv4.defineMessages)({
    edited: {
        id: "page-card.action.you.edited",
        defaultMessage: "You edited {timeAgo}"
    },
    visited: {
        id: "page-card.action.you.visited",
        defaultMessage: "You visited {timeAgo}"
    },
    updated: {
        id: "page-card.action.updated",
        defaultMessage: "Updated {timeAgo}"
    },
    created: {
        id: "page-card.action.created",
        defaultMessage: "Created {timeAgo}"
    },
    createdByYou: {
        id: "page-card.action.created.by.me",
        defaultMessage: "You created {timeAgo}"
    },
    ownedByYou: {
        id: "page-card.action.owned.by.me",
        defaultMessage: "You became owner {timeAgo}"
    },
    liked: {
        id: "page-card.action.liked",
        defaultMessage: "You liked {timeAgo}"
    },
    commented: {
        id: "page-card.action.commented",
        defaultMessage: "You commented {timeAgo}"
    }
});
const $5445257a17f279b7$var$Icons = {
    edited: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
    visited: (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
    updated: (0, (/*@__PURE__*/$parcel$interopDefault($kevJM))),
    created: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
    createdByYou: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
    ownedByYou: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
    liked: (0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))),
    commented: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28)))
};
const $5445257a17f279b7$var$LastActionContainerStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle'
});
const $5445257a17f279b7$var$lastActionTextBaseStyles = null;
const $5445257a17f279b7$var$textMarginLeft = null;
const $5445257a17f279b7$var$separatorStyles = (0, $ecnYn.xcss)({
    margin: 'space.050'
});
const $5445257a17f279b7$export$6d375014d3e4edb5 = ({ isInlineAction: isInlineAction = false, appearance: appearance })=>{
    const { lastAction: { action: action, when: when } } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const Icon = action && $5445257a17f279b7$var$Icons[action];
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: $5445257a17f279b7$var$LastActionContainerStyles,
        ...isNav4Enabled && appearance === 'list' ? {
            justifyContent: 'end'
        } : {}
    }, action && when ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !isNav4Enabled && Icon && !isInlineAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        color: "var(--ds-text-subtle, #505258)",
        label: "",
        testId: "last-action-icon",
        spacing: "none"
    }), isInlineAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5445257a17f279b7$var$separatorStyles
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _syazuqch",
            !isNav4Enabled && !isInlineAction && "_18u0u2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$5445257a17f279b7$var$i18n[action],
        values: {
            timeAgo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: when,
                usePrepositions: true
            })
        }
    }))) : null);
};
module.exports["LastAction"] = $5445257a17f279b7$export$6d375014d3e4edb5;

});

parcelRegister("eSkJX", function(module, exports) {
/* Subtitle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $jJK3p = parcelRequire("jJK3p");


var $9wGTI = parcelRequire("9wGTI");


var $AXitC = parcelRequire("AXitC");


var $jsaQN = parcelRequire("jsaQN");


var $cxMI6 = parcelRequire("cxMI6");

const $2476ccb0e5f98391$var$i18n = (0, $cgtv4.defineMessages)({
    createdBy: {
        id: "page-card.created.by",
        defaultMessage: "Created by {creator}"
    },
    creatorProfilePictureAlt: {
        id: "page-card.creator.image.label",
        defaultMessage: "Profile picture"
    },
    ownedBy: {
        id: "page-card.owned.by",
        defaultMessage: "Owned by {owner}"
    },
    ownerProfilePictureAlt: {
        id: "page-card.owner.image.label",
        defaultMessage: "Profile picture"
    }
});
const $2476ccb0e5f98391$var$linkStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$CreatorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81o8v _1pbyidpf _o5721q9c _1e0c1txw _4cvr1h6o _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact && "_17kn15vq _1hrp15vq _10ca1q9c _x3fa1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$OwnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81o8v _1pbyidpf _o5721q9c _1e0c1txw _4cvr1h6o _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact && "_17kn15vq _1hrp15vq _10ca1q9c _x3fa1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2476ccb0e5f98391$var$SpaceLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81o8v _1pbykb7n _1bto1l2s _syazazsu _kqswh2mm _1ufy15vq _turg15vq _43dsuqch _bpspi7a9 _sjfo1q9c _2cf31l2s _p03cuqch _oavvuqch _oxk4uqch _1cayuqch",
            __cmplp.compact ? "_dkzun7od" : "_dkzu1y44",
            __cmplp.className
        ])
    });
});
const $2476ccb0e5f98391$var$Creator = ({ displayName: displayName, accountId: accountId })=>{
    const { appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === 'compact-list';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$CreatorContainer, {
        compact: compact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$2476ccb0e5f98391$var$i18n.createdBy,
        values: {
            creator: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                userId: accountId,
                fullName: displayName,
                referralSource: "pageCard"
            })
        }
    }));
};
const $2476ccb0e5f98391$var$Owner = ({ displayName: displayName, accountId: accountId })=>{
    const { appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === 'compact-list';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$OwnerContainer, {
        compact: compact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$2476ccb0e5f98391$var$i18n.ownedBy,
        values: {
            owner: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
                userId: accountId,
                fullName: displayName,
                referralSource: "pageCard"
            })
        }
    }));
};
const $2476ccb0e5f98391$var$Space = ({ name: name, spaceKey: spaceKey })=>{
    const context = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { appearance: appearance } = context;
    const compact = appearance === 'compact-list';
    const endOfPage = appearance === 'end-of-page';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: (0, $cxMI6.isSpacePageCard)(context) ? 'spacePageCardSpace' : 'globalPageCardSpace',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    appearance: appearance
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        appearance,
        context
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$SpaceLink, {
        compact: compact,
        endOfPage: endOfPage
    }, (0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__disco') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }),
        onClick: handleClick
    }, name) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }),
        onClick: handleClick
    }, name));
};
const $2476ccb0e5f98391$export$cf345ef34cd72655 = ()=>{
    const data = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    if ((0, $cxMI6.isSpacePageCard)(data)) // check if page ownership is enabled and ownedBy
    // field is not null to account for anonymous users
    // blogs only use createdBy since they intentially don't allow owners to be changed
    return data?.ownedBy && data?.type !== 'blogpost' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$Owner, data.ownedBy) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$Creator, data.createdBy);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2476ccb0e5f98391$var$Space, data.space);
};
module.exports["Subtitle"] = $2476ccb0e5f98391$export$cf345ef34cd72655;

});

parcelRegister("jb4sa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $AXitC = parcelRequire("AXitC");


var $7tW57 = parcelRequire("7tW57");

const $18021647e567f5f6$export$6890bd4131e19e85 = /*#__PURE__*/ (0, $42omo.memo)(({ appearance: appearance, data: data, ranking: ranking, analyticsData: analyticsData, children: children, smallCard: smallCard })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const [isViewed, setIsViewed] = (0, $42omo.useState)(false);
    const [selectedMenuItems, setSelectedMenuItems] = (0, $42omo.useState)({
        [(0, $7tW57.QuickActionsEnum).ShareButton]: false,
        [(0, $7tW57.QuickActionsEnum).WatchButton]: false
    });
    const pageCardContextValue = (0, $42omo.useMemo)(()=>{
        return {
            ...data,
            appearance: appearance,
            setIsMenuOpen: setIsMenuOpen,
            isMenuOpen: isMenuOpen,
            ranking: ranking,
            setSelectedMenuItems: setSelectedMenuItems,
            selectedMenuItems: selectedMenuItems,
            analyticsData: analyticsData,
            isViewed: isViewed,
            setIsViewed: setIsViewed,
            smallCard: smallCard
        };
    }, [
        data,
        appearance,
        ranking,
        analyticsData,
        isMenuOpen,
        selectedMenuItems,
        isViewed,
        smallCard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AXitC.PageCardContext).Provider, {
        value: pageCardContextValue
    }, children);
}, (prevProps, nextProps)=>prevProps.appearance === nextProps.appearance && prevProps.data.isStarred === nextProps.data.isStarred);
module.exports["PageCardContextProvider"] = $18021647e567f5f6$export$6890bd4131e19e85;

});

parcelRegister("5BwjK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f4Buk = parcelRequire("f4Buk");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $AXitC = parcelRequire("AXitC");


var $7aRa9 = parcelRequire("7aRa9");

const $38667f05992adc43$var$WrappedButton = ({ flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { id: id, type: type, title: title } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    return cloudId && (0, $9wGTI.fg)('confluence_audio_briefings_v3') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f4Buk.ModifyPlaylistButton), {
        cloudId: cloudId,
        contentId: id,
        contentType: type,
        title: title.text,
        flags: flags
    });
};
const $38667f05992adc43$export$dbccb879127f2ec0 = (0, $7aRa9.withFlags)($38667f05992adc43$var$WrappedButton);
module.exports["AudioPlaylistButton"] = $38667f05992adc43$export$dbccb879127f2ec0;

});

parcelRegister("f4Buk", function(module, exports) {

var $l998X = parcelRequire("l998X");

/**
 * @generated SignedSource<<5f75830e202ad2aa7e5c24dadf09d0f5>>
 * @relayHash 6a8eb5830f313d77241c92d27560daf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb5f84e794494496dbe1d4bd3d661b90c42b7f2ebf2943035a6d037b22dd7fc6
const $52d5115c3b247f1d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "mainContent",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ModifyPlaylistButtonsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ModifyPlaylistButtonsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluencePlaylist",
                    "kind": "LinkedField",
                    "name": "confluence_getPlaylist",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluencePaginatedTracks",
                            "kind": "LinkedField",
                            "name": "tracks",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceTrack",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eb5f84e794494496dbe1d4bd3d661b90c42b7f2ebf2943035a6d037b22dd7fc6",
            "metadata": {},
            "name": "ModifyPlaylistButtonsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$52d5115c3b247f1d$var$node.hash = "9a16b2985017e28685206d1dd12e52b3";
var $52d5115c3b247f1d$export$2e2bcd8739ae039 = $52d5115c3b247f1d$var$node;



var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $irOoi = parcelRequire("irOoi");


var $1qfLF = parcelRequire("1qfLF");


var $3DMri = parcelRequire("3DMri");


var $lkdqP = parcelRequire("lkdqP");


var $2Ihtu = parcelRequire("2Ihtu");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");


var $6AYaN = parcelRequire("6AYaN");


var $1WGfE = parcelRequire("1WGfE");

const $6820f7566b5808dd$var$messages = (0, $cgtv4.defineMessages)({
    addToPlaylistText: {
        id: "ai-audio.playlist.button.addToPlaylist-label",
        defaultMessage: "Add to playlist"
    },
    removeFromPlaylistText: {
        id: "ai-audio.playlist.button.removeFromPlaylist-label",
        defaultMessage: "Remove from playlist"
    },
    inPlaylistText: {
        id: "ai-audio.playlist.button.inPlaylist-label",
        defaultMessage: "Added to playlist"
    }
});
const $6820f7566b5808dd$var$styles = {
    container: "_4t3izwfg _1bsbzwfg",
    round: "_2rko1rr0 _1reozryt _18m9zryt _1h6d1l7x _189ee4h9 _1dqonqa1"
};
const $6820f7566b5808dd$export$76382f4393cd85be = ({ testId: testId, cloudId: //for testing
cloudId, contentId: //needed to generate ari
contentId, contentType: //needed to mutate
contentType, trackType: //needed to mutate and for ari
trackType, top: //optional default: NARRATION or BRIEFING
top, flags: //optional to add the new track to the top of the playlist default: false
flags //Flags Container
 })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { addTrack: addTrack, isAdding: isAdding } = (0, $1WGfE.useContextMenuActions)(flags, cloudId);
    const addToPlaylist = (0, $42omo.useCallback)(async ()=>{
        await addTrack((0, $6AYaN.getConfluenceContentAri)(cloudId, contentId, contentType)?.toString() || '', [], trackType || 'BRIEFING');
    }, [
        cloudId,
        contentId,
        contentType,
        trackType,
        addTrack
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($6820f7566b5808dd$var$messages.addToPlaylistText),
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3DMri))),
                testId: testId && `${testId}-add`,
                label: formatMessage($6820f7566b5808dd$var$messages.addToPlaylistText),
                ...tooltipProps,
                onClick: addToPlaylist,
                isDisabled: isAdding
            })
    });
};
const $6820f7566b5808dd$export$ce1b020c3f0567a5 = ({ testId: testId, title: //for testing
title, cloudId: //for success flag text
cloudId, contentId: //needed to generate ari
contentId, contentType: //needed to mutate
contentType, trackType: //needed to mutate and for ari
trackType, flags: //optional default: NARRATION or BRIEFING
flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { removeTrack: removeTrack, isRemoving: isRemoving } = (0, $1WGfE.useContextMenuActions)(flags, cloudId);
    const removeFromPlaylist = (0, $42omo.useCallback)(async ()=>{
        await removeTrack((0, $6AYaN.getConfluenceContentAri)(cloudId, contentId, contentType)?.toString() || '', [], trackType || 'BRIEFING', title);
    }, [
        cloudId,
        contentId,
        contentType,
        trackType,
        title,
        removeTrack
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($6820f7566b5808dd$var$messages.removeFromPlaylistText),
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Ihtu))),
                testId: testId && `${testId}-remove`,
                label: formatMessage($6820f7566b5808dd$var$messages.removeFromPlaylistText),
                ...tooltipProps,
                onClick: removeFromPlaylist,
                isDisabled: isRemoving
            })
    });
};
const $6820f7566b5808dd$export$9c768a8c290b2144 = ({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage($6820f7566b5808dd$var$messages.inPlaylistText),
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($lkdqP))),
                testId: testId && `${testId}-added`,
                label: formatMessage($6820f7566b5808dd$var$messages.inPlaylistText),
                ...tooltipProps
            })
    });
};
const $6820f7566b5808dd$export$1d966ac7ff8e1b07 = ({ testId: testId, title: // test ID
title, round: //text for remove flag
round, _defaultEngagement_do_not_use: //applies rounded CSS treatment
_defaultEngagement_do_not_use = false, cloudId: cloudId, contentId: //needed to generate ari
contentId, contentType: //needed to mutate
contentType, trackType: //needed to mutate and for ari
trackType, flags: //optional default: NARRATION or BRIEFING
flags })=>{
    const playlist = (0, $irOoi.useLazyLoadQuery)((0, $52d5115c3b247f1d$export$2e2bcd8739ae039), {
        cloudId: cloudId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const isInPlaylist = (0, $42omo.useMemo)(()=>{
        if (!playlist?.confluence_getPlaylist?.tracks?.nodes) return false;
        const contentIds = playlist.confluence_getPlaylist.tracks.nodes.map((node)=>node?.mainContent?.id).filter(Boolean) || [];
        return contentIds.includes(contentId);
    }, [
        playlist,
        contentId
    ]);
    const [isEnagaged, setIsEngaged] = (0, $42omo.useState)(_defaultEngagement_do_not_use);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default // Set the state to true when the mouse enters or the element receives focus
        ), {
            onMouseEnter: ()=>setIsEngaged(true),
            onFocus: ()=>setIsEngaged(true),
            onMouseLeave: ()=>setIsEngaged(false),
            onBlur: ()=>setIsEngaged(false),
            xcss: (0, $1bHXt.cx)($6820f7566b5808dd$var$styles.container, round && $6820f7566b5808dd$var$styles.round),
            children: isInPlaylist ? !isEnagaged ? /*#__PURE__*/ (0, $l998X.jsx)($6820f7566b5808dd$export$9c768a8c290b2144, {
                testId: testId
            }) : /*#__PURE__*/ (0, $l998X.jsx)($6820f7566b5808dd$export$ce1b020c3f0567a5, {
                testId: testId,
                cloudId: cloudId,
                contentId: contentId,
                contentType: contentType,
                trackType: trackType,
                flags: flags,
                title: title
            }) : /*#__PURE__*/ (0, $l998X.jsx)($6820f7566b5808dd$export$76382f4393cd85be, {
                testId: testId,
                cloudId: cloudId,
                contentId: contentId,
                contentType: contentType,
                trackType: trackType,
                flags: flags
            })
        })
    });
};
const $6820f7566b5808dd$export$a239151f44937f5c = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($6820f7566b5808dd$export$1d966ac7ff8e1b07, {
            ...props
        })
    });
};
module.exports["ModifyPlaylistButton"] = $6820f7566b5808dd$export$a239151f44937f5c;

});

parcelRegister("6AYaN", function(module, exports) {

var $dv2RR = parcelRequire("dv2RR");

var $9ekTs = parcelRequire("9ekTs");

var $hLgiF = parcelRequire("hLgiF");

const $254c2956a05882e1$export$6a2f2c83863e9bfe = (siteId, contentId, contentType)=>{
    try {
        switch(contentType){
            case 'page':
                return (0, $9ekTs.ConfluencePageAri).create({
                    siteId: siteId,
                    pageId: contentId
                });
            case 'blogpost':
                return (0, $dv2RR.ConfluenceBlogpostAri).create({
                    siteId: siteId,
                    blogpostId: contentId
                });
            case 'whiteboard':
                return (0, $hLgiF.ConfluenceWhiteboardAri).create({
                    siteId: siteId,
                    whiteboardId: contentId
                });
        }
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getConfluenceContentAri"] = $254c2956a05882e1$export$6a2f2c83863e9bfe;

});

parcelRegister("1WGfE", function(module, exports) {

var $l998X = parcelRequire("l998X");

/**
 * @generated SignedSource<<3a67299abe9624ba14390f47c245f6b6>>
 * @relayHash 09b1ed877ed8f3d928d49949049c592f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0787ddf5866783a1ce1b6da1cecbc7ba8428cdc70682beb2f91304617267174f
const $4ec33f42f6c58035$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "ConfluenceAddTrackPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "concreteType": "ConfluenceAddTrackPayloadErrorExtension",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    }
                ]
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "ScalarField",
        "name": "mainSource"
    }, v7 = {
        "kind": "ScalarField",
        "name": "supportingSources"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextMenuActionsAddTrackMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceAddTrackPayload",
                    "kind": "LinkedField",
                    "name": "confluence_addTrack",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceTrack",
                            "kind": "LinkedField",
                            "name": "track",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "mainContent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextMenuActionsAddTrackMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceAddTrackPayload",
                    "kind": "LinkedField",
                    "name": "confluence_addTrack",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceTrack",
                            "kind": "LinkedField",
                            "name": "track",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "mainContent",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v12 /*: any*/ ,
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0787ddf5866783a1ce1b6da1cecbc7ba8428cdc70682beb2f91304617267174f",
            "metadata": {},
            "name": "useContextMenuActionsAddTrackMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$4ec33f42f6c58035$var$node.hash = "3726f92913dc05d9ac0144c9ea15c358";
var $4ec33f42f6c58035$export$2e2bcd8739ae039 = $4ec33f42f6c58035$var$node;


/**
 * @generated SignedSource<<6a0f668a87762ac89dceb92e308b6733>>
 * @relayHash 6dbdbe4a62543b90fa6c0a2b3bb68c6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 08d80dad1041c3f20d85c84d8afb8c5ec82779d04c25add523b3c8f265d56e74
const $8c20097d408b3640$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceReorderTrackPayload",
            "kind": "LinkedField",
            "name": "confluence_reorderTracks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceReorderTrackPayloadError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "concreteType": "ConfluenceReorderTrackPayloadErrorExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextMenuActionsReorderTrackMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextMenuActionsReorderTrackMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "08d80dad1041c3f20d85c84d8afb8c5ec82779d04c25add523b3c8f265d56e74",
            "metadata": {},
            "name": "useContextMenuActionsReorderTrackMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8c20097d408b3640$var$node.hash = "5739afa9f8b36d85167f2ad0033521ff";
var $8c20097d408b3640$export$2e2bcd8739ae039 = $8c20097d408b3640$var$node;


/**
 * @generated SignedSource<<71a4baefc141277ffa3823930965d96c>>
 * @relayHash 090a309bae12fcddd73edaf12962aaa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID db1e2dd71d5da02d4d53f36625768a7dc322cd38beb182692d3f32ad6195812c
const $edeb3d32f2d24ca6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceRemoveTrackPayload",
            "kind": "LinkedField",
            "name": "confluence_removeTrack",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceRemoveTrackPayloadError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "concreteType": "ConfluenceRemoveTrackPayloadErrorExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContextMenuActionsRemoveTrackMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContextMenuActionsRemoveTrackMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "db1e2dd71d5da02d4d53f36625768a7dc322cd38beb182692d3f32ad6195812c",
            "metadata": {},
            "name": "useContextMenuActionsRemoveTrackMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$edeb3d32f2d24ca6$var$node.hash = "a82da56f002288d2c61caae485db7176";
var $edeb3d32f2d24ca6$export$2e2bcd8739ae039 = $edeb3d32f2d24ca6$var$node;



var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $irOoi = parcelRequire("irOoi");


var $3sFtD = parcelRequire("3sFtD");


var $9s8in = parcelRequire("9s8in");

const $43dc6744ccb145bd$var$messages = (0, $cgtv4.defineMessages)({
    reorderSuccessTitle: {
        id: "ai-audio.playlist.reorder-success-description",
        defaultMessage: "Moved {title}"
    },
    reorderErrorDescription: {
        id: "ai-audio.playlist.reorder-error-description",
        defaultMessage: "Failed to move item in playlist"
    },
    removeSuccess: {
        id: "ai-audio.playlist.remove-success",
        defaultMessage: "Removed from playlist"
    },
    errorTitle: {
        id: "ai-audio.playlist.error",
        defaultMessage: "Something went wrong"
    },
    removeSuccessDescription: {
        id: "ai-audio.playlist.remove-success-description",
        defaultMessage: "{title} has been removed from your playlist"
    },
    removeErrorDescription: {
        id: "ai-audio.playlist.remove-error-description",
        defaultMessage: "Failed to remove item from playlist"
    },
    addSuccess: {
        id: "ai-audio.playlist.add-success",
        defaultMessage: "Added to playlist"
    },
    addError: {
        id: "ai-audio.playlist.add-error",
        defaultMessage: "Something went wrong"
    },
    addSuccessDescription: {
        id: "ai-audio.playlist.add-success-description",
        defaultMessage: "Listen anywhere on Confluence or the mobile app"
    },
    addErrorDescription: {
        id: "ai-audio.playlist.add-error-description",
        defaultMessage: "Failed to add item to playlist"
    }
});
/**
 * Helper function to check if a track node matches the given track parameters
 */ const $43dc6744ccb145bd$var$isMatchingTrack = (node, mainSource, trackType, supportingSources)=>{
    if (node?.getValue('mainSource') !== mainSource || node?.getValue('type') !== trackType) return false;
    const nodeSupportingSources = node?.getValue('supportingSources') || [];
    // Check that arrays have the same length first
    if (nodeSupportingSources.length !== supportingSources.length) return false;
    // Then check that all elements match
    return nodeSupportingSources.every((source, index)=>source === supportingSources[index]);
};
const $43dc6744ccb145bd$export$fb508b9bcc816326 = (flags, argCloudId)=>{
    const { cloudId: storeCloudID } = (0, $9s8in.useAudioPlayerStore)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    //consumers can call hooks even when the audio player is collapsed. In this case the audoPLayerStore won't exist, and they should bootstrap with their own cloudID.
    const cloudId = argCloudId || storeCloudID;
    const [removeTrackMutation, isRemoveMutationInFlight] = (0, $irOoi.useMutation)((0, $edeb3d32f2d24ca6$export$2e2bcd8739ae039));
    const [reorderTrackMutation, isReorderMutationInFlight] = (0, $irOoi.useMutation)((0, $8c20097d408b3640$export$2e2bcd8739ae039));
    const removeTrack = (0, $42omo.useCallback)((mainSource, supportingSources, trackType, title)=>{
        return new Promise((resolve, reject)=>{
            removeTrackMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        mainSource: mainSource,
                        supportingSources: supportingSources,
                        trackType: trackType
                    }
                },
                onCompleted: (response)=>{
                    const success = response.confluence_removeTrack?.success;
                    const errors = response.confluence_removeTrack?.errors;
                    if (success) {
                        resolve(true);
                        if (flags && title) flags.showFlag({
                            type: 'success',
                            title: formatMessage($43dc6744ccb145bd$var$messages.removeSuccess),
                            description: formatMessage($43dc6744ccb145bd$var$messages.removeSuccessDescription, {
                                title: title
                            }),
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                spacing: "spacious",
                                color: "var(--ds-icon-success, #6A9A23)",
                                label: "success"
                            }),
                            close: 'auto'
                        });
                    } else {
                        const errorMessage = errors?.[0]?.message || 'Failed to remove track';
                        reject(new Error(errorMessage));
                        if (flags) flags.showFlag({
                            title: formatMessage($43dc6744ccb145bd$var$messages.errorTitle),
                            description: formatMessage($43dc6744ccb145bd$var$messages.removeErrorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: (error)=>{
                    reject(error);
                    if (flags) flags.showFlag({
                        title: formatMessage($43dc6744ccb145bd$var$messages.errorTitle),
                        description: formatMessage($43dc6744ccb145bd$var$messages.removeErrorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                },
                updater: (store)=>{
                    // Update the Relay store to remove the track from the cache
                    // This ensures the UI updates immediately without refetching
                    const playlistRecord = store.getRoot().getLinkedRecord('confluence_getPlaylist', {
                        cloudId: cloudId
                    });
                    if (playlistRecord) {
                        const tracksRecord = playlistRecord.getLinkedRecord('tracks');
                        if (tracksRecord) {
                            const nodes = tracksRecord.getLinkedRecords('nodes');
                            if (nodes) {
                                const updatedNodes = nodes.filter((node)=>!$43dc6744ccb145bd$var$isMatchingTrack(node, mainSource, trackType, supportingSources));
                                tracksRecord.setLinkedRecords(updatedNodes, 'nodes');
                            }
                        }
                    }
                }
            });
        });
    }, [
        removeTrackMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    const [addTrackMutation, isAddMutationInFlight] = (0, $irOoi.useMutation)((0, $4ec33f42f6c58035$export$2e2bcd8739ae039));
    const addTrack = (0, $42omo.useCallback)((mainSource, supportingSources = [], trackType)=>{
        return new Promise((resolve, reject)=>{
            addTrackMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        track: {
                            mainSource: mainSource,
                            supportingSources: supportingSources,
                            trackType: trackType || 'BRIEFING'
                        },
                        top: true
                    }
                },
                onCompleted: (response)=>{
                    const success = response.confluence_addTrack?.success;
                    const errors = response.confluence_addTrack?.errors;
                    if (success) {
                        resolve(true);
                        flags?.showFlag({
                            title: formatMessage($43dc6744ccb145bd$var$messages.addSuccess),
                            description: formatMessage($43dc6744ccb145bd$var$messages.addSuccessDescription),
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                spacing: "spacious",
                                color: "var(--ds-icon-success, #6A9A23)",
                                label: "success"
                            }),
                            type: 'success',
                            close: 'auto'
                        });
                    } else {
                        const errorMessage = errors?.[0]?.message || 'Failed to add track';
                        reject(new Error(errorMessage));
                        flags?.showFlag({
                            title: formatMessage($43dc6744ccb145bd$var$messages.addError),
                            description: formatMessage($43dc6744ccb145bd$var$messages.addErrorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: ()=>{
                    reject(new Error('Failed to add track'));
                    flags?.showFlag({
                        title: formatMessage($43dc6744ccb145bd$var$messages.addError),
                        description: formatMessage($43dc6744ccb145bd$var$messages.addErrorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                },
                updater: (store)=>{
                    // Update the Relay store to add/move the track to the top of the playlist
                    const payload = store.getRootField('confluence_addTrack');
                    const newTrack = payload?.getLinkedRecord('track');
                    if (!payload?.getValue('success') || !newTrack) return;
                    const playlist = store.getRoot().getLinkedRecord('confluence_getPlaylist', {
                        cloudId: cloudId
                    });
                    const tracks = playlist?.getLinkedRecord('tracks');
                    if (!tracks) return;
                    const nodes = tracks.getLinkedRecords('nodes') || [];
                    // Check if the track already exists in the playlist
                    const existingTrackIndex = nodes.findIndex((node)=>$43dc6744ccb145bd$var$isMatchingTrack(node, mainSource, trackType, supportingSources));
                    let updatedNodes;
                    if (existingTrackIndex !== -1) {
                        // Track exists: remove it from its current position and add to top
                        const filteredNodes = nodes.filter((node)=>!$43dc6744ccb145bd$var$isMatchingTrack(node, mainSource, trackType, supportingSources));
                        updatedNodes = [
                            newTrack,
                            ...filteredNodes
                        ];
                    } else // Track doesn't exist: just add to top
                    updatedNodes = [
                        newTrack,
                        ...nodes
                    ];
                    tracks.setLinkedRecords(updatedNodes, 'nodes');
                }
            });
        });
    }, [
        cloudId,
        addTrackMutation,
        flags,
        formatMessage
    ]);
    /**
   * • Target track - The track being repositioned
   * • Reference track - The track that serves as the anchor point. The target track will be placed immediately after
   *    the reference track. If no reference track is specified, the target track moves to the beginning of the playlist.
   */ const reorderTrack = (0, $42omo.useCallback)((targetTrack, referenceTrack, title)=>{
        return new Promise((resolve, reject)=>{
            reorderTrackMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        targetTrack: targetTrack,
                        referenceTrack: referenceTrack
                    }
                },
                onCompleted: (response)=>{
                    const success = response.confluence_reorderTracks?.success;
                    const errors = response.confluence_reorderTracks?.errors;
                    if (success) {
                        resolve(true);
                        if (flags && title) flags.showFlag({
                            title: formatMessage($43dc6744ccb145bd$var$messages.reorderSuccessTitle, {
                                title: title
                            }),
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                spacing: "spacious",
                                color: "var(--ds-icon-success, #6A9A23)",
                                label: "success"
                            }),
                            close: 'auto'
                        });
                    } else {
                        const errorMessage = errors?.[0]?.message || 'Failed to reorder track';
                        reject(new Error(errorMessage));
                        if (flags) flags.showFlag({
                            title: formatMessage($43dc6744ccb145bd$var$messages.errorTitle),
                            description: formatMessage($43dc6744ccb145bd$var$messages.reorderErrorDescription),
                            type: 'error',
                            close: 'auto'
                        });
                    }
                },
                onError: (error)=>{
                    reject(error);
                    if (flags) flags.showFlag({
                        title: formatMessage($43dc6744ccb145bd$var$messages.errorTitle),
                        description: formatMessage($43dc6744ccb145bd$var$messages.reorderErrorDescription),
                        type: 'error',
                        close: 'auto'
                    });
                }
            });
        });
    }, [
        reorderTrackMutation,
        cloudId,
        flags,
        formatMessage
    ]);
    return {
        removeTrack: removeTrack,
        isRemoving: isRemoveMutationInFlight,
        isDisabled: isRemoveMutationInFlight || isReorderMutationInFlight,
        addTrack: addTrack,
        isAdding: isAddMutationInFlight,
        reorderTrack: reorderTrack
    };
};
module.exports["useContextMenuActions"] = $43dc6744ccb145bd$export$fb508b9bcc816326;

});

parcelRegister("9s8in", function(module, exports) {

var $lbhE8 = parcelRequire("lbhE8");


var $lqUMo = parcelRequire("lqUMo");

const $4adad3a8665dccf2$export$cba1cb68876d4742 = ()=>{
    const state = (0, $lbhE8.useAtom)((0, $lqUMo.audioPlayerState));
    return {
        // State
        isOpen: state.isOpen,
        isPlaying: state.isPlaying,
        isPaused: state.isPaused,
        activeContent: state.activeContent,
        activeFeature: state.activeFeature,
        activeMenu: state.activeMenu,
        pendingContent: state.pendingContent,
        cloudId: state.cloudId,
        customization: state.customization,
        openAudioPlayer: // Actions
        $lqUMo.openAudioPlayer,
        closeAudioPlayer: $lqUMo.closeAudioPlayer,
        activatePendingContent: $lqUMo.activatePendingContent,
        clearPendingContent: $lqUMo.clearPendingContent,
        setIsPlaying: $lqUMo.setIsPlaying,
        setIsPaused: $lqUMo.setIsPaused,
        updatePlayerState: $lqUMo.updatePlayerState,
        setActiveFeature: $lqUMo.setActiveFeature,
        setActiveMenu: $lqUMo.setActiveMenu,
        setCustomization: $lqUMo.setCustomization
    };
};
module.exports["useAudioPlayerStore"] = $4adad3a8665dccf2$export$cba1cb68876d4742;

});

parcelRegister("lbhE8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9TRAA = parcelRequire("9TRAA");

function $f6b8503d65355db8$var$defaultCompare(a, b) {
    return a === b;
}
function $f6b8503d65355db8$var$identity(snapshot) {
    return snapshot;
}
function $f6b8503d65355db8$var$useSelectorWithCompare(selector, compare) {
    const previous = (0, $42omo.useRef)(undefined);
    return (snapshot)=>{
        const next = selector(snapshot);
        return previous.current && compare(previous.current, next) ? previous.current : previous.current = next;
    };
}
/**
 * A React hook that subscribes to the `store` and selects a value from the
 * store's snapshot, with an optional compare function.
 *
 * @example
 *
 * ```ts
 * function Component() {
 *   const count = useSelector(store, (s) => s.count);
 *
 *   return <div>{count}</div>;
 * }
 * ```
 *
 * @param store The store, created from `createStore(…)`
 * @param selector A function which takes in the `snapshot` and returns a
 *   selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 * @returns The selected value
 */ function $f6b8503d65355db8$export$2105062e25df4afe(store, selector, compare = $f6b8503d65355db8$var$defaultCompare) {
    const selectorWithCompare = $f6b8503d65355db8$var$useSelectorWithCompare(selector, compare);
    return (0, $42omo.useSyncExternalStore)((0, $42omo.useCallback)((handleStoreChange)=>store.subscribe(handleStoreChange).unsubscribe, [
        store
    ]), ()=>selectorWithCompare(store.get()), ()=>selectorWithCompare(store.get()));
}
const $f6b8503d65355db8$export$6ccbb43953eebf8 = function useStoreImpl(definition) {
    const storeRef = (0, $42omo.useRef)(undefined);
    if (!storeRef.current) storeRef.current = (0, $9TRAA.a)(definition);
    return storeRef.current;
};
/**
 * A React hook that subscribes to the `atom` and returns the current value of
 * the atom.
 *
 * @example
 *
 * ```ts
 * const atom = createAtom(0);
 *
 * const Component = () => {
 *   const count = useAtom(atom);
 *
 *   return (
 *     <div>
 *       <div>{count}</div>
 *       <button onClick={() => atom.set((c) => c + 1)}>Increment</button>
 *     </div>
 *   );
 * };
 * ```
 *
 * @param atom The atom, created from `createAtom(…)`
 * @param selector An optional function which takes in the `snapshot` and
 *   returns a selected value
 * @param compare An optional function which compares the selected value to the
 *   previous value
 */ function $f6b8503d65355db8$export$83cf7ae8bb57e7ed(atom, selector = $f6b8503d65355db8$var$identity, compare = $f6b8503d65355db8$var$defaultCompare) {
    const state = $f6b8503d65355db8$export$2105062e25df4afe(atom, selector, compare);
    return state;
}
/**
 * Creates a custom hook that returns the selected value and the store from a
 * store configuration object.
 *
 * @example
 *
 * ```ts
 * const useCountStore = createStoreHook({
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => ({
 *       ...context,
 *       count: context.count + event.by
 *     })
 *   }
 * });
 *
 * function Component() {
 *   const [count, store] = useCountStore(s => s.context.count);
 *
 *   return (
 *     <div>
 *       {count}
 *       <button onClick={() => store.trigger.inc({ by: 1 })}>+</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * @param definition The store configuration object
 * @returns A custom hook that returns [selectedValue, store]
 */ function $f6b8503d65355db8$export$671dba69185d0304(definition) {
    const store = (0, $9TRAA.a)(definition);
    function useStoreHook(selector, compare = $f6b8503d65355db8$var$defaultCompare) {
        // If no selector provided, return full snapshot
        if (!selector) {
            const snapshot = $f6b8503d65355db8$export$2105062e25df4afe(store, $f6b8503d65355db8$var$identity, $f6b8503d65355db8$var$defaultCompare);
            return [
                snapshot,
                store
            ];
        }
        // Use selector with comparison
        const selectedValue = $f6b8503d65355db8$export$2105062e25df4afe(store, selector ?? $f6b8503d65355db8$var$identity, compare);
        return [
            selectedValue,
            store
        ];
    }
    return useStoreHook;
}
module.exports["useAtom"] = $f6b8503d65355db8$export$83cf7ae8bb57e7ed;

});

parcelRegister("9TRAA", function(module, exports) {
/* eslint-disable */ function $7352d1cb7623abab$var$createReactiveSystem({ update: update, notify: notify, unwatched: unwatched }) {
    let currentVersion = 0;
    return {
        link: link,
        unlink: unlink,
        propagate: propagate,
        checkDirty: checkDirty,
        endTracking: endTracking,
        startTracking: startTracking,
        shallowPropagate: shallowPropagate
    };
    function link(dep, sub) {
        const prevDep = sub._depsTail;
        if (prevDep !== undefined && prevDep.dep === dep) return;
        const nextDep = prevDep !== undefined ? prevDep.nextDep : sub._deps;
        if (nextDep !== undefined && nextDep.dep === dep) {
            nextDep.version = currentVersion;
            sub._depsTail = nextDep;
            return;
        }
        const prevSub = dep._subsTail;
        if (prevSub !== undefined && prevSub.version === currentVersion && prevSub.sub === sub) return;
        const newLink = sub._depsTail = dep._subsTail = {
            version: currentVersion,
            dep: dep,
            sub: sub,
            prevDep: prevDep,
            nextDep: nextDep,
            prevSub: prevSub,
            nextSub: undefined
        };
        if (nextDep !== undefined) nextDep.prevDep = newLink;
        if (prevDep !== undefined) prevDep.nextDep = newLink;
        else sub._deps = newLink;
        if (prevSub !== undefined) prevSub.nextSub = newLink;
        else dep._subs = newLink;
    }
    function unlink(link, sub = link.sub) {
        const dep = link.dep;
        const prevDep = link.prevDep;
        const nextDep = link.nextDep;
        const nextSub = link.nextSub;
        const prevSub = link.prevSub;
        if (nextDep !== undefined) nextDep.prevDep = prevDep;
        else sub._depsTail = prevDep;
        if (prevDep !== undefined) prevDep.nextDep = nextDep;
        else sub._deps = nextDep;
        if (nextSub !== undefined) nextSub.prevSub = prevSub;
        else dep._subsTail = prevSub;
        if (prevSub !== undefined) prevSub.nextSub = nextSub;
        else if ((dep._subs = nextSub) === undefined) unwatched(dep);
        return nextDep;
    }
    function propagate(link) {
        let next = link.nextSub;
        let stack;
        top: do {
            const sub = link.sub;
            let flags = sub._flags;
            if (!(flags & 60)) sub._flags = flags | 32;
            else if (!(flags & 12)) flags = 0;
            else if (!(flags & 4)) sub._flags = flags & -9 | 32;
            else if (!(flags & 48) && isValidLink(link, sub)) {
                sub._flags = flags | 40;
                flags &= 1;
            } else flags = 0;
            if (flags & 2) notify(sub);
            if (flags & 1) {
                const subSubs = sub._subs;
                if (subSubs !== undefined) {
                    const nextSub = (link = subSubs).nextSub;
                    if (nextSub !== undefined) {
                        stack = {
                            value: next,
                            prev: stack
                        };
                        next = nextSub;
                    }
                    continue;
                }
            }
            if ((link = next) !== undefined) {
                next = link.nextSub;
                continue;
            }
            while(stack !== undefined){
                link = stack.value;
                stack = stack.prev;
                if (link !== undefined) {
                    next = link.nextSub;
                    continue top;
                }
            }
            break;
        }while (true);
    }
    function startTracking(sub) {
        ++currentVersion;
        sub._depsTail = undefined;
        sub._flags = sub._flags & -57 | 4;
    }
    function endTracking(sub) {
        const depsTail = sub._depsTail;
        let toRemove = depsTail !== undefined ? depsTail.nextDep : sub._deps;
        while(toRemove !== undefined)toRemove = unlink(toRemove, sub);
        sub._flags &= -5;
    }
    function checkDirty(link, sub) {
        let stack;
        let checkDepth = 0;
        top: do {
            const dep = link.dep;
            const flags = dep._flags;
            let dirty = false;
            if (sub._flags & 16) dirty = true;
            else if ((flags & 17) === 17) {
                if (update(dep)) {
                    const subs = dep._subs;
                    if (subs.nextSub !== undefined) shallowPropagate(subs);
                    dirty = true;
                }
            } else if ((flags & 33) === 33) {
                if (link.nextSub !== undefined || link.prevSub !== undefined) stack = {
                    value: link,
                    prev: stack
                };
                link = dep._deps;
                sub = dep;
                ++checkDepth;
                continue;
            }
            if (!dirty) {
                const nextDep = link.nextDep;
                if (nextDep !== undefined) {
                    link = nextDep;
                    continue;
                }
            }
            while(checkDepth--){
                const firstSub = sub._subs;
                const hasMultipleSubs = firstSub.nextSub !== undefined;
                if (hasMultipleSubs) {
                    link = stack.value;
                    stack = stack.prev;
                } else link = firstSub;
                if (dirty) {
                    if (update(sub)) {
                        if (hasMultipleSubs) shallowPropagate(firstSub);
                        sub = link.sub;
                        continue;
                    }
                } else sub._flags &= -33;
                sub = link.sub;
                const nextDep = link.nextDep;
                if (nextDep !== undefined) {
                    link = nextDep;
                    continue top;
                }
                dirty = false;
            }
            return dirty;
        }while (true);
    }
    function shallowPropagate(link) {
        do {
            const sub = link.sub;
            const flags = sub._flags;
            if ((flags & 48) === 32) {
                sub._flags = flags | 16;
                if (flags & 2) notify(sub);
            }
        }while ((link = link.nextSub) !== undefined);
    }
    function isValidLink(checkLink, sub) {
        let link = sub._depsTail;
        while(link !== undefined){
            if (link === checkLink) return true;
            link = link.prevDep;
        }
        return false;
    }
}
function $7352d1cb7623abab$var$toObserver(nextHandler, errorHandler, completionHandler) {
    const isObserver = typeof nextHandler === 'object';
    const self = isObserver ? nextHandler : undefined;
    return {
        next: (isObserver ? nextHandler.next : nextHandler)?.bind(self),
        error: (isObserver ? nextHandler.error : errorHandler)?.bind(self),
        complete: (isObserver ? nextHandler.complete : completionHandler)?.bind(self)
    };
}
const $7352d1cb7623abab$var$queuedEffects = [];
const { link: $7352d1cb7623abab$var$link, unlink: $7352d1cb7623abab$var$unlink, propagate: $7352d1cb7623abab$var$propagate, checkDirty: $7352d1cb7623abab$var$checkDirty, endTracking: $7352d1cb7623abab$var$endTracking, startTracking: $7352d1cb7623abab$var$startTracking, shallowPropagate: $7352d1cb7623abab$var$shallowPropagate } = $7352d1cb7623abab$var$createReactiveSystem({
    update (atom) {
        return atom._update();
    },
    notify (effect) {
        $7352d1cb7623abab$var$queuedEffects[$7352d1cb7623abab$var$queuedEffectsLength++] = effect;
    },
    unwatched (atom) {
        let toRemove = atom._deps;
        if (toRemove !== undefined) {
            atom._flags = 17;
            do toRemove = $7352d1cb7623abab$var$unlink(toRemove, atom);
            while (toRemove !== undefined);
        }
    }
});
let $7352d1cb7623abab$var$notifyIndex = 0;
let $7352d1cb7623abab$var$queuedEffectsLength = 0;
let $7352d1cb7623abab$var$activeSub;
function $7352d1cb7623abab$var$flush() {
    while($7352d1cb7623abab$var$notifyIndex < $7352d1cb7623abab$var$queuedEffectsLength){
        const effect = $7352d1cb7623abab$var$queuedEffects[$7352d1cb7623abab$var$notifyIndex];
        $7352d1cb7623abab$var$queuedEffects[$7352d1cb7623abab$var$notifyIndex++] = undefined;
        effect.notify();
    }
    $7352d1cb7623abab$var$notifyIndex = 0;
    $7352d1cb7623abab$var$queuedEffectsLength = 0;
}
function $7352d1cb7623abab$export$2d1720544b23b823(getValue, options) {
    const atom = $7352d1cb7623abab$export$f1e1789686576879(()=>{
        getValue().then((data)=>{
            if (atom._update({
                status: 'done',
                data: data
            })) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7352d1cb7623abab$var$propagate(subs);
                    $7352d1cb7623abab$var$shallowPropagate(subs);
                    $7352d1cb7623abab$var$flush();
                }
            }
        }, (error)=>{
            if (atom._update({
                status: 'error',
                error: error
            })) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7352d1cb7623abab$var$propagate(subs);
                    $7352d1cb7623abab$var$shallowPropagate(subs);
                    $7352d1cb7623abab$var$flush();
                }
            }
        });
        return {
            status: 'pending'
        };
    }, options);
    return atom;
}
function $7352d1cb7623abab$export$f1e1789686576879(valueOrFn, options) {
    const isComputed = typeof valueOrFn === 'function';
    const getter = valueOrFn;
    // Create plain object atom
    const atom = {
        _snapshot: isComputed ? undefined : valueOrFn,
        _subs: undefined,
        _subsTail: undefined,
        _flags: 0,
        get () {
            if ($7352d1cb7623abab$var$activeSub !== undefined) $7352d1cb7623abab$var$link(atom, $7352d1cb7623abab$var$activeSub);
            return atom._snapshot;
        },
        subscribe (observerOrFn) {
            const obs = $7352d1cb7623abab$var$toObserver(observerOrFn);
            const observed = {
                current: false
            };
            const e = $7352d1cb7623abab$var$effect(()=>{
                atom.get();
                if (!observed.current) observed.current = true;
                else obs.next?.(atom._snapshot);
            });
            return {
                unsubscribe: ()=>{
                    e.stop();
                }
            };
        },
        _update (getValue) {
            const prevSub = $7352d1cb7623abab$var$activeSub;
            const compare = options?.compare ?? Object.is;
            $7352d1cb7623abab$var$activeSub = atom;
            $7352d1cb7623abab$var$startTracking(atom);
            try {
                const oldValue = atom._snapshot;
                const read = (atom)=>atom.get();
                const newValue = typeof getValue === 'function' ? getValue(oldValue) : getValue === undefined && isComputed ? getter(read) : getValue;
                if (oldValue === undefined || !compare(oldValue, newValue)) {
                    atom._snapshot = newValue;
                    return true;
                }
                return false;
            } finally{
                $7352d1cb7623abab$var$activeSub = prevSub;
                $7352d1cb7623abab$var$endTracking(atom);
            }
        }
    };
    if (isComputed) Object.assign(atom, {
        _deps: undefined,
        _depsTail: undefined,
        _flags: 17,
        get () {
            const flags = this._flags;
            if (flags & 16 || flags & 32 && $7352d1cb7623abab$var$checkDirty(atom._deps, atom)) {
                if (atom._update()) {
                    const subs = atom._subs;
                    if (subs !== undefined) $7352d1cb7623abab$var$shallowPropagate(subs);
                }
            } else if (flags & 32) atom._flags = flags & -33;
            if ($7352d1cb7623abab$var$activeSub !== undefined) $7352d1cb7623abab$var$link(atom, $7352d1cb7623abab$var$activeSub);
            return atom._snapshot;
        }
    });
    else Object.assign(atom, {
        set (valueOrFn) {
            if (atom._update(valueOrFn)) {
                const subs = atom._subs;
                if (subs !== undefined) {
                    $7352d1cb7623abab$var$propagate(subs);
                    $7352d1cb7623abab$var$shallowPropagate(subs);
                    $7352d1cb7623abab$var$flush();
                }
            }
        }
    });
    return atom;
}
function $7352d1cb7623abab$var$effect(fn) {
    const run = ()=>{
        const prevSub = $7352d1cb7623abab$var$activeSub;
        $7352d1cb7623abab$var$activeSub = effectObj;
        $7352d1cb7623abab$var$startTracking(effectObj);
        try {
            return fn();
        } finally{
            $7352d1cb7623abab$var$activeSub = prevSub;
            $7352d1cb7623abab$var$endTracking(effectObj);
        }
    };
    const effectObj = {
        _deps: undefined,
        _depsTail: undefined,
        _flags: 2,
        notify () {
            const flags = this._flags;
            if (flags & 16 || flags & 32 && $7352d1cb7623abab$var$checkDirty(this._deps, this)) run();
            else if (flags & 32) this._flags = flags & -33;
        },
        stop () {
            $7352d1cb7623abab$var$startTracking(this);
            $7352d1cb7623abab$var$endTracking(this);
        }
    };
    run();
    return effectObj;
}
const $7352d1cb7623abab$var$symbolObservable = (()=>typeof Symbol === 'function' && Symbol.observable || '@@observable')();
const $7352d1cb7623abab$var$inspectionObservers = new WeakMap();
function $7352d1cb7623abab$var$createStoreCore(logic, emits) {
    let listeners;
    const initialSnapshot = logic.getInitialSnapshot();
    let currentSnapshot = initialSnapshot;
    const atom = $7352d1cb7623abab$export$f1e1789686576879(currentSnapshot);
    const emit = (ev)=>{
        if (!listeners) return;
        const type = ev.type;
        const typeListeners = listeners.get(type);
        if (typeListeners) typeListeners.forEach((listener)=>listener(ev));
    };
    const transition = logic.transition;
    function receive(event) {
        const [nextSnapshot, effects] = transition(currentSnapshot, event);
        currentSnapshot = nextSnapshot;
        $7352d1cb7623abab$var$inspectionObservers.get(store)?.forEach((observer)=>{
            observer.next?.({
                type: '@xstate.snapshot',
                event: event,
                snapshot: nextSnapshot,
                actorRef: store,
                rootId: store.sessionId
            });
        });
        atom.set(nextSnapshot);
        for (const effect of effects)if (typeof effect === 'function') effect();
        else {
            // handle the inherent effect first
            emits?.[effect.type]?.(effect);
            emit(effect);
        }
    }
    const store = {
        get _snapshot () {
            return atom._snapshot;
        },
        on (emittedEventType, handler) {
            if (!listeners) listeners = new Map();
            let eventListeners = listeners.get(emittedEventType);
            if (!eventListeners) {
                eventListeners = new Set();
                listeners.set(emittedEventType, eventListeners);
            }
            const wrappedHandler = handler.bind(undefined);
            eventListeners.add(wrappedHandler);
            return {
                unsubscribe () {
                    eventListeners.delete(wrappedHandler);
                }
            };
        },
        transition: logic.transition,
        // TODO: fix this
        sessionId: $7352d1cb7623abab$var$uniqueId(),
        send (event) {
            $7352d1cb7623abab$var$inspectionObservers.get(store)?.forEach((observer)=>{
                observer.next?.({
                    type: '@xstate.event',
                    event: event,
                    sourceRef: undefined,
                    actorRef: store,
                    rootId: store.sessionId
                });
            });
            receive(event);
        },
        getSnapshot () {
            return currentSnapshot;
        },
        get () {
            return atom.get();
        },
        getInitialSnapshot () {
            return initialSnapshot;
        },
        subscribe: atom.subscribe.bind(atom),
        [$7352d1cb7623abab$var$symbolObservable] () {
            return this;
        },
        inspect: (observerOrFn)=>{
            const observer = $7352d1cb7623abab$var$toObserver(observerOrFn);
            $7352d1cb7623abab$var$inspectionObservers.set(store, $7352d1cb7623abab$var$inspectionObservers.get(store) ?? new Set());
            $7352d1cb7623abab$var$inspectionObservers.get(store).add(observer);
            observer.next?.({
                type: '@xstate.actor',
                actorRef: store,
                rootId: store.sessionId
            });
            observer.next?.({
                type: '@xstate.snapshot',
                snapshot: initialSnapshot,
                event: {
                    type: '@xstate.init'
                },
                actorRef: store,
                rootId: store.sessionId
            });
            return {
                unsubscribe () {
                    return $7352d1cb7623abab$var$inspectionObservers.get(store)?.delete(observer);
                }
            };
        },
        trigger: new Proxy({}, {
            get: (_, eventType)=>{
                return (payload)=>{
                    store.send({
                        ...payload,
                        type: eventType
                    });
                };
            }
        }),
        select (selector, equalityFn = Object.is) {
            return $7352d1cb7623abab$export$f1e1789686576879(()=>selector(store.get().context), {
                compare: equalityFn
            });
        }
    };
    return store;
}
/**
 * Creates a **store** that has its own internal state and can be sent events
 * that update its internal state based on transitions.
 *
 * @example
 *
 * ```ts
 * const store = createStore({
 *   context: { count: 0, name: 'Ada' },
 *   on: {
 *     inc: (context, event: { by: number }) => ({
 *       ...context,
 *       count: context.count + event.by
 *     })
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5, name: 'Ada' }, status: 'active', ... }
 * ```
 *
 * @param config - The store configuration object
 * @param config.context - The initial state of the store
 * @param config.on - An object mapping event types to transition functions
 * @param config.emits - An object mapping emitted event types to handlers
 * @returns A store instance with methods to send events and subscribe to state
 *   changes
 */ function $7352d1cb7623abab$export$407448d2b89b1813(definitionOrLogic) {
    if ('transition' in definitionOrLogic) return $7352d1cb7623abab$var$createStoreCore(definitionOrLogic);
    const transition = $7352d1cb7623abab$export$db3b6bfb95261072(definitionOrLogic.on);
    const logic = {
        getInitialSnapshot: ()=>({
                status: 'active',
                context: definitionOrLogic.context,
                output: undefined,
                error: undefined
            }),
        transition: transition
    };
    return $7352d1cb7623abab$var$createStoreCore(logic, definitionOrLogic.emits);
}
function $7352d1cb7623abab$var$_createStoreConfig(definition) {
    return definition;
}
const $7352d1cb7623abab$export$4368d992c4eafac0 = $7352d1cb7623abab$var$_createStoreConfig;
/**
 * Creates a `Store` with a provided producer (such as Immer's `producer(…)` A
 * store has its own internal state and can receive events.
 *
 * @example
 *
 * ```ts
 * import { produce } from 'immer';
 *
 * const store = createStoreWithProducer(produce, {
 *   context: { count: 0 },
 *   on: {
 *     inc: (context, event: { by: number }) => {
 *       context.count += event.by;
 *     }
 *   }
 * });
 *
 * store.subscribe((snapshot) => {
 *   console.log(snapshot);
 * });
 *
 * store.send({ type: 'inc', by: 5 });
 * // Logs { context: { count: 5 }, status: 'active', ... }
 * ```
 */ function $7352d1cb7623abab$export$8b22cf2602fb60ce(producer, config) {
    const transition = $7352d1cb7623abab$export$db3b6bfb95261072(config.on, producer);
    const logic = {
        getInitialSnapshot: ()=>({
                status: 'active',
                context: config.context,
                output: undefined,
                error: undefined
            }),
        transition: transition
    };
    return $7352d1cb7623abab$var$createStoreCore(logic, config.emits);
}
/**
 * Creates a store transition function that handles state updates based on
 * events.
 *
 * @param transitions - An object mapping event types to transition functions
 * @param producer - Optional producer function (e.g., Immer's produce) for
 *   immutable updates
 * @returns A transition function that takes a snapshot and event and returns a
 *   new snapshot with effects
 */ function $7352d1cb7623abab$export$db3b6bfb95261072(transitions, producer) {
    return (snapshot, event)=>{
        const currentContext = snapshot.context;
        const assigner = transitions?.[event.type];
        const effects = [];
        const enqueue = {
            emit: new Proxy({}, {
                get: (_, eventType)=>{
                    return (payload)=>{
                        effects.push({
                            ...payload,
                            type: eventType
                        });
                    };
                }
            }),
            effect: (fn)=>{
                effects.push(fn);
            }
        };
        if (!assigner) return [
            snapshot,
            effects
        ];
        const nextContext = producer ? producer(currentContext, (draftContext)=>assigner(draftContext, event, enqueue)) : assigner(currentContext, event, enqueue) ?? currentContext;
        return [
            nextContext === currentContext ? snapshot : {
                ...snapshot,
                context: nextContext
            },
            effects
        ];
    };
}
/**
 * Generates a unique 6-character identifier.
 *
 * @returns A random string identifier
 */ function $7352d1cb7623abab$var$uniqueId() {
    return Math.random().toString(36).slice(6);
}
module.exports["e"] = $7352d1cb7623abab$export$f1e1789686576879;
module.exports["a"] = $7352d1cb7623abab$export$407448d2b89b1813;

});

parcelRegister("lqUMo", function(module, exports) {

var $9TRAA = parcelRequire("9TRAA");


var $CAM5Y = parcelRequire("CAM5Y");


var $7qD3Z = parcelRequire("7qD3Z");

const $7698e90cebff2064$var$DEFAULT_AUDIO_FEATURE = (0, $CAM5Y.AudioFeatureType).BRIEFING;
const $7698e90cebff2064$var$DEFAULT_CUSTOMIZATION = {
    tone: (0, $7qD3Z.CustomTone).PROFESSIONAL,
    length: (0, $7qD3Z.CustomLength).SHORT
};
const $7698e90cebff2064$var$initialState = {
    activeContent: {
        contentId: '',
        spaceKey: '',
        contentType: '',
        title: '',
        author: '',
        avatarUrl: ''
    },
    activeFeature: $7698e90cebff2064$var$DEFAULT_AUDIO_FEATURE,
    pendingContent: null,
    isOpen: false,
    isPlaying: false,
    isPaused: false,
    product: '',
    cloudId: '',
    activationId: '',
    customization: $7698e90cebff2064$var$DEFAULT_CUSTOMIZATION
};
const $7698e90cebff2064$export$cdbb2fdff9747f37 = (0, $9TRAA.e)($7698e90cebff2064$var$initialState);
const $7698e90cebff2064$export$4bf748e973a0a732 = (activeContent)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeContent: activeContent,
            // Reset playback states when switching to a new track
            isPlaying: false,
            isPaused: false
        }));
};
const $7698e90cebff2064$export$30d2a851f8b14636 = (activeFeature)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeFeature: activeFeature
        }));
};
const $7698e90cebff2064$export$fa9442b044bf53f8 = (activeMenu)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            activeMenu: activeMenu
        }));
};
const $7698e90cebff2064$export$dfa73cfe44e75105 = (contentToOpen)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>{
        // Check if the content is already active
        const isAlreadyActive = prevState.activeContent.contentId === contentToOpen.contentId;
        // Check if the content is already pending
        const isAlreadyPending = prevState.pendingContent?.contentId === contentToOpen.contentId;
        // If content is already active or pending, do nothing
        if (isAlreadyActive || isAlreadyPending) return prevState;
        // If player is already open, set new content as pending
        if (prevState.isOpen) return {
            ...prevState,
            pendingContent: contentToOpen
        };
        // Otherwise, set as active content and open player
        return {
            ...prevState,
            activeContent: contentToOpen,
            isOpen: true
        };
    });
};
const $7698e90cebff2064$export$dba664cdc5e8fbf4 = ()=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>{
        if (prevState.pendingContent) return {
            ...prevState,
            activeContent: prevState.pendingContent,
            pendingContent: null,
            isPlaying: false,
            isPaused: false
        };
        return prevState;
    });
};
const $7698e90cebff2064$export$feb15da72003eb0f = ()=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            pendingContent: null
        }));
};
const $7698e90cebff2064$export$c7e4afd074cdd19a = ()=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set($7698e90cebff2064$var$initialState);
};
const $7698e90cebff2064$export$92debfee183fcd0e = (isPlaying)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            isPlaying: isPlaying
        }));
};
const $7698e90cebff2064$export$8e7c7df046bd1f47 = (isPaused)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            isPaused: isPaused
        }));
};
const $7698e90cebff2064$export$36bd232e206b82e1 = (updates)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>({
            ...prevState,
            ...updates
        }));
};
const $7698e90cebff2064$export$5163deecba0c25e4 = (newCustomization)=>{
    $7698e90cebff2064$export$cdbb2fdff9747f37.set((prevState)=>{
        const { customization: customization } = prevState;
        const updatedCustomization = {
            ...customization,
            ...newCustomization
        };
        return {
            ...prevState,
            customization: updatedCustomization
        };
    });
};
module.exports["audioPlayerState"] = $7698e90cebff2064$export$cdbb2fdff9747f37;
module.exports["setActiveContent"] = $7698e90cebff2064$export$4bf748e973a0a732;
module.exports["setActiveFeature"] = $7698e90cebff2064$export$30d2a851f8b14636;
module.exports["setActiveMenu"] = $7698e90cebff2064$export$fa9442b044bf53f8;
module.exports["openAudioPlayer"] = $7698e90cebff2064$export$dfa73cfe44e75105;
module.exports["activatePendingContent"] = $7698e90cebff2064$export$dba664cdc5e8fbf4;
module.exports["clearPendingContent"] = $7698e90cebff2064$export$feb15da72003eb0f;
module.exports["closeAudioPlayer"] = $7698e90cebff2064$export$c7e4afd074cdd19a;
module.exports["setIsPlaying"] = $7698e90cebff2064$export$92debfee183fcd0e;
module.exports["setIsPaused"] = $7698e90cebff2064$export$8e7c7df046bd1f47;
module.exports["updatePlayerState"] = $7698e90cebff2064$export$36bd232e206b82e1;
module.exports["setCustomization"] = $7698e90cebff2064$export$5163deecba0c25e4;

});

parcelRegister("CAM5Y", function(module, exports) {
var $53b8f68bbadfad1e$export$1e95f84c3271729c = /*#__PURE__*/ function(AudioFeatureType) {
    AudioFeatureType["BRIEFING"] = "briefing";
    AudioFeatureType["NARRATION"] = "narration";
    return AudioFeatureType;
}({});
module.exports["AudioFeatureType"] = $53b8f68bbadfad1e$export$1e95f84c3271729c;

});

parcelRegister("7qD3Z", function(module, exports) {
const $ebde027041ae9db2$export$22914fe597403470 = {
    PLAYFUL: 'playful',
    PROFESSIONAL: 'professional',
    CONVERSATIONAL: 'conversational',
    SURPRISE: 'surprise'
};
const $ebde027041ae9db2$export$91791b32a6f45c02 = {
    SHORT: 'short',
    MEDIUM: 'medium',
    LONG: 'long'
};
module.exports["CustomTone"] = $ebde027041ae9db2$export$22914fe597403470;
module.exports["CustomLength"] = $ebde027041ae9db2$export$91791b32a6f45c02;

});

parcelRegister("qaY7H", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $tgs13 = parcelRequire("tgs13");


var $jmjWc = parcelRequire("jmjWc");


const $0831fbd07aa65085$export$24022e96df95ff7e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "IH0no",
    name: "LazyAutomationDiscoveryHoverPageTitleMessage",
    loader: async ()=>(await (parcelRequire("iosid"))).AutomationDiscoveryHoverPageTitleMessage
});



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $cLo2u = parcelRequire("cLo2u");


var $AXitC = parcelRequire("AXitC");

const $2d4afef340cfe0b2$export$731d798c62feb243 = (lastModifiedDate)=>{
    const getPageUpdatedInSeconds = (lastModifiedRaw)=>{
        const lastModifiedDate = new Date(lastModifiedRaw);
        return (Date.now() - lastModifiedDate.getTime()) / 1000;
    };
    return getPageUpdatedInSeconds(lastModifiedDate) > (0, $tgs13.THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS);
};
const $2d4afef340cfe0b2$var$AutomationDiscoveryMessageInner = ({ shouldUseAutomationDiscovery: shouldUseAutomationDiscovery })=>{
    const { status: status, lastAction: { when: when }, type: type } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const shouldRender = shouldUseAutomationDiscovery && type === 'page' && status !== 'draft' && $2d4afef340cfe0b2$export$731d798c62feb243(when);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0831fbd07aa65085$export$24022e96df95ff7e), {
        spaceKey: spaceKey
    }));
};
const $2d4afef340cfe0b2$export$162d8a771575bc85 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($2d4afef340cfe0b2$var$AutomationDiscoveryMessageInner);
module.exports["AutomationDiscoveryMessage"] = $2d4afef340cfe0b2$export$162d8a771575bc85;

});

parcelRegister("iosid", function(module, exports) {

let $d6406a3c289eea27$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6406a3c289eea27$var$load("6wr18"),
    $d6406a3c289eea27$var$load("gtMen"),
    $d6406a3c289eea27$var$load("hhss7"),
    $d6406a3c289eea27$var$load("ffEVr"),
    $d6406a3c289eea27$var$load("1NKZf")
]).then(()=>parcelRequire('byS2e'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("1R1bQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9FnLD = parcelRequire("9FnLD");


var $1yB28 = parcelRequire("1yB28");


var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $gz8ZY = parcelRequire("gz8ZY");


var $AXitC = parcelRequire("AXitC");

const $0e708e5e8b7bc139$var$i18n = (0, $cgtv4.defineMessages)({
    likes: {
        id: "page-card.social.likes",
        defaultMessage: "likes"
    },
    comments: {
        id: "page-card.social.comments",
        defaultMessage: "comments"
    }
});
const $0e708e5e8b7bc139$var$socialProofContainerStylesNav3 = (0, $ecnYn.xcss)({
    color: 'color.text.subtle'
});
const $0e708e5e8b7bc139$var$socialProofContainerStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $0e708e5e8b7bc139$var$countStylesNav3 = (0, $ecnYn.xcss)({
    font: 'font.heading.xxsmall',
    marginLeft: 'space.025'
});
const $0e708e5e8b7bc139$var$countStyles = (0, $ecnYn.xcss)({
    font: 'font.body.small',
    marginLeft: 'space.025',
    fontWeight: 'font.weight.regular'
});
const $0e708e5e8b7bc139$export$d0fb2e88e6204069 = ()=>{
    const { likesCount: likesCount, commentsCount: commentsCount } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $8C5kA.default)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        xcss: isNav4Enabled ? $0e708e5e8b7bc139$var$socialProofContainerStyles : $0e708e5e8b7bc139$var$socialProofContainerStylesNav3,
        ...isNav4Enabled ? {
            columnGap: 'space.150'
        } : {
            columnGap: 'space.075'
        }
    }, likesCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        ...isNav4Enabled && {
            columnGap: 'space.025'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
        label: intl.formatMessage($0e708e5e8b7bc139$var$i18n.likes)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: isNav4Enabled ? $0e708e5e8b7bc139$var$countStyles : $0e708e5e8b7bc139$var$countStylesNav3
    }, likesCount)) : null, commentsCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        ...isNav4Enabled && {
            columnGap: 'space.025'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: intl.formatMessage($0e708e5e8b7bc139$var$i18n.comments)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: isNav4Enabled ? $0e708e5e8b7bc139$var$countStyles : $0e708e5e8b7bc139$var$countStylesNav3
    }, commentsCount)) : null);
};
module.exports["SocialProof"] = $0e708e5e8b7bc139$export$d0fb2e88e6204069;

});

parcelRegister("4c4ke", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $bl4QJ = parcelRequire("bl4QJ");


const $6572a38c2b754de3$export$7a3e91558b835213 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G6aNu",
    name: "WatchDialog",
    loader: async ()=>(await (parcelRequire("byBLX"))).WatchDialog,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
module.exports["WatchDialog"] = $6572a38c2b754de3$export$7a3e91558b835213;

});

parcelRegister("byBLX", function(module, exports) {

let $86a02b82c886e8db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86a02b82c886e8db$var$load("89WyM"),
    $86a02b82c886e8db$var$load("fZt2F"),
    $86a02b82c886e8db$var$load("e2ujj"),
    $86a02b82c886e8db$var$load("cUtrS")
]).then(()=>parcelRequire('bzo9I'));

});

parcelRegister("3dPSK", function(module, exports) {
/**
 This function is used in the Content Types header to determine if the Watch dialog should
 appear for a specific content type (i.e whiteboards/databases and any future content types)
 */ const $660080b0a61a732e$export$75ba55e1c62d2f65 = (contentType)=>{
    return contentType === 'whiteboard' || contentType === 'database';
};
module.exports["useIsWatchDialogEnabled"] = $660080b0a61a732e$export$75ba55e1c62d2f65;

});

parcelRegister("dDu9z", function(module, exports) {
/* PopupView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $inPa6 = parcelRequire("inPa6");


var $71GjD = parcelRequire("71GjD");


var $5BwjK = parcelRequire("5BwjK");

var $qaY7H = parcelRequire("qaY7H");

var $aoeyL = parcelRequire("aoeyL");

var $gETnG = parcelRequire("gETnG");

var $c9Olr = parcelRequire("c9Olr");

var $dDr80 = parcelRequire("dDr80");

var $9CEYG = parcelRequire("9CEYG");

var $1R1bQ = parcelRequire("1R1bQ");

var $fROKr = parcelRequire("fROKr");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");

const $f2ffb31ca33bfa58$var$styles = {
    container: "_1bsb1kdj",
    headerStyle: "_1reo15vq _18m915vq _1bsb1osq _1i4q1hna _1nmz9jpi _1bto1l2s",
    headerIconStyle: "_1e0c1txw _1bah1yb4 _1wpz1y6m",
    titleContainer: "_11c8nbxd _1reo15vq _18m915vq _1bto1l2s _1i4q1hna _1e0ccj1k _5nh5cs5v _sudp1e54"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2ffb31ca33bfa58$var$FooterContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _4cvresu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2ffb31ca33bfa58$var$Footer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _19pkpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f2ffb31ca33bfa58$var$CardFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1R1bQ.SocialProof), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5BwjK.AudioPlaylistButton), null)));
const $f2ffb31ca33bfa58$export$52243c6737c37941 = ({ shouldUseAutomationDiscovery: shouldUseAutomationDiscovery, isEndOfPage: isEndOfPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$PopupViewBase, {
        isEndOfPage: isEndOfPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
        shouldHideFolder: true,
        featureAttributionCode: isEndOfPage ? (0, $71GjD.FeatureCode).EOP_REC_CARD : (0, $71GjD.FeatureCode).PAGE_TREE_CARD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        padding: "space.200",
        xcss: $f2ffb31ca33bfa58$var$styles.container,
        testId: "page-card-popup-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignBlock: "start",
        alignInline: "start",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        alignInline: "start",
        shouldWrap: false,
        grow: "fill",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $f2ffb31ca33bfa58$var$styles.headerIconStyle,
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $f2ffb31ca33bfa58$var$styles.headerStyle,
        alignBlock: "start",
        alignInline: "start",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $f2ffb31ca33bfa58$var$styles.titleContainer,
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), {
        isInColumn: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gETnG.Excerpt), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f2ffb31ca33bfa58$var$CardFooter, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qaY7H.AutomationDiscoveryMessage), {
        shouldUseAutomationDiscovery: shouldUseAutomationDiscovery
    }));
};
const $f2ffb31ca33bfa58$var$PopupViewBase = ({ children: children, isEndOfPage: isEndOfPage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handlePopupClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluence',
                action: 'clicked',
                actionSubject: isEndOfPage ? 'relatedContentCard' : 'spacePageCard',
                actionSubjectId: 'excerptPopup',
                attributes: {
                    source: isEndOfPage ? 'endOfPageRecommendations' : 'pageTree'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isEndOfPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
        isHoverPageCard: true,
        onClick: handlePopupClick
    }, children);
};
module.exports["PopupView"] = $f2ffb31ca33bfa58$export$52243c6737c37941;

});

parcelRegister("3acIx", function(module, exports) {
/* PageCards.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $4JDbp = parcelRequire("4JDbp");


var $gz8ZY = parcelRequire("gz8ZY");




/* CompactListView.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dDr80 = parcelRequire("dDr80");

var $aoeyL = parcelRequire("aoeyL");

var $c9Olr = parcelRequire("c9Olr");

var $9CEYG = parcelRequire("9CEYG");
/* QuickActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bQm3c = parcelRequire("bQm3c");


var $3dPSK = parcelRequire("3dPSK");


var $2cKGu = parcelRequire("2cKGu");


var $AXitC = parcelRequire("AXitC");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1Zr9M = parcelRequire("1Zr9M");


var $3gadb = parcelRequire("3gadb");


var $de2j9 = parcelRequire("de2j9");


var $sD2Tz = parcelRequire("sD2Tz");


var $jlIaF = parcelRequire("jlIaF");


var $56QzY = parcelRequire("56QzY");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");




/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $eEA8O = parcelRequire("eEA8O");

const $9435f53888e733e2$export$3c1d9e6f68d6384d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701wzwfg",
            __cmplp.isSelected ? "_1w901bgf" : "_1w90124n",
            __cmplp.className
        ])
    });
});



var $jsaQN = parcelRequire("jsaQN");

/* ActionContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 






// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $146c0ee07cc94a7d$var$HiddenAction = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_v564fxgs _tzy41eg2",
            __cmplp.className
        ])
    });
});
const $146c0ee07cc94a7d$var$StaticAction = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pbykb7n",
            __cmplp.className
        ])
    });
});
const $146c0ee07cc94a7d$export$37ab3bdebc286ca = ({ children: children })=>{
    const { hidden: hidden } = (0, $42omo.useContext)((0, $7f1b580bd70ac23d$export$e53fea40f770c4e5));
    const Container = hidden ? $146c0ee07cc94a7d$var$HiddenAction : $146c0ee07cc94a7d$var$StaticAction;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Container, null, children);
};


const $cea5a5dbb111468f$var$i18n = (0, $cgtv4.defineMessages)({
    edit: {
        id: "page-card.quick-actions.edit.page",
        defaultMessage: "Edit"
    },
    editLabel: {
        id: "page-card.quick-actions.edit.aria-label",
        defaultMessage: "Edit {title}"
    }
});
const $cea5a5dbb111468f$export$a8d3280cb45e38b8 = ()=>{
    const { id: id, space: space, type: type, links: { editui: editui }, appearance: appearance, title: title, editorVersion: editorVersion } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const intl = (0, $8C5kA.default)();
    const spaceKey = space?.spaceKey;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const compact = appearance === 'compact-list';
    // @ts-ignore editorVersion is not typed correctly in the PageCardContext as here it comes
    // and is accessed a fragment of the ADF document rather than a string
    const editorVersionValue = editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, '');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const fireClickAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: 'editButton',
                attributes: {
                    navdexPointType: (0, $56QzY.END),
                    pageType: type,
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        type,
        isOnEditRoute
    ]);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        fireClickAnalytics();
        e.preventDefault();
        e.stopPropagation();
        loadEditor({
            contentId: id,
            spaceKey: spaceKey,
            redirectUrl: `${(0, $jlIaF.CONTEXT_PATH)}${editui}`,
            isFabricSupported: editorVersionValue === 'v2',
            isEmbeddedContent: false
        });
    }, [
        fireClickAnalytics,
        loadEditor,
        id,
        spaceKey,
        editui,
        editorVersionValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
        key: id,
        contentId: id,
        spaceKey: spaceKey,
        isEmbeddedEditor: false,
        editSource: (0, $7NoF3.PAGECARD_EDIT_BUTTON_CLICK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($cea5a5dbb111468f$var$i18n.edit),
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
        spacing: compact ? 'compact' : 'default',
        onClick: handleClick,
        href: `${(0, $jlIaF.CONTEXT_PATH)}${editui}`,
        appearance: "subtle",
        "aria-label": intl.formatMessage($cea5a5dbb111468f$var$i18n.editLabel, {
            title: title.text
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    }))));
};


/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");










var $7hXu9 = parcelRequire("7hXu9");

var $1KmJq = parcelRequire("1KmJq");


var $kfYj7 = parcelRequire("kfYj7");





var $b3j2Y = parcelRequire("b3j2Y");


var $bvJMy = parcelRequire("bvJMy");


var $gw4Eo = parcelRequire("gw4Eo");





var $li6DS = parcelRequire("li6DS");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");












const $b6404efbbcc25998$var$StarButtonPageFragment = (0, $eSUdr.default)`fragment StarButtonPageFragment on ConfluencePage{viewer{favoritedSummary{isFavorite}}}`;
const $b6404efbbcc25998$var$StarButtonBlogPostFragment = (0, $eSUdr.default)`fragment StarButtonBlogPostFragment on ConfluenceBlogPost{viewer{favoritedSummary{isFavorite}}}`;
const $b6404efbbcc25998$var$StarButtonWhiteboardFragment = (0, $eSUdr.default)`fragment StarButtonWhiteboardFragment on ConfluenceWhiteboard{viewer{favoritedSummary{isFavorite}}}`;
const $b6404efbbcc25998$var$StarButtonDatabaseFragment = (0, $eSUdr.default)`fragment StarButtonDatabaseFragment on ConfluenceDatabase{viewer{favoritedSummary{isFavorite}}}`;
const $b6404efbbcc25998$var$StarButtonEmbedFragment = (0, $eSUdr.default)`fragment StarButtonEmbedFragment on ConfluenceEmbed{viewer{favoritedSummary{isFavorite}}}`;
const $b6404efbbcc25998$var$StarButtonFolderFragment = (0, $eSUdr.default)`fragment StarButtonFolderFragment on ConfluenceFolder{viewer{favoritedSummary{isFavorite}}}`;
const $b6404efbbcc25998$var$starButtonFragments = {
    page: $b6404efbbcc25998$var$StarButtonPageFragment,
    blogpost: $b6404efbbcc25998$var$StarButtonBlogPostFragment,
    whiteboard: $b6404efbbcc25998$var$StarButtonWhiteboardFragment,
    database: $b6404efbbcc25998$var$StarButtonDatabaseFragment,
    embed: $b6404efbbcc25998$var$StarButtonEmbedFragment,
    folder: $b6404efbbcc25998$var$StarButtonFolderFragment
};
const $b6404efbbcc25998$export$81b167aa686d9284 = (type)=>$b6404efbbcc25998$var$starButtonFragments[type];
// For forming the typename correctly for content types to enable optimistic updates
const $b6404efbbcc25998$var$capitalizedContentTypes = {
    page: 'Page',
    blogpost: 'BlogPost',
    database: 'Database',
    whiteboard: 'Whiteboard',
    embed: 'Embed',
    folder: 'Folder'
};
const $b6404efbbcc25998$export$caa6fc1b5639be76 = (type)=>$b6404efbbcc25998$var$capitalizedContentTypes[type];


const $04fcbb12dec9cb03$var$StarButtonPageCardStarMutation = (0, $eSUdr.default)`mutation StarButtonPageCardStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id metadata{currentuser{favourited{isFavourite}}}}}}`;
const $04fcbb12dec9cb03$var$StarButtonPageCardUnstarMutation = (0, $eSUdr.default)`mutation StarButtonPageCardUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id metadata{currentuser{favourited{isFavourite}}}}}}`;
const $04fcbb12dec9cb03$var$i18n = (0, $cgtv4.defineMessages)({
    star: {
        id: "page-card.star.content.tooltip.label",
        defaultMessage: "Star"
    },
    unstar: {
        id: "page-card.unstar.content.tooltip.label",
        defaultMessage: "Unstar"
    }
});
const $04fcbb12dec9cb03$export$b4b5678234ca6d4d = ()=>{
    const { id: id, type: type, isStarred: isStarred, appearance: appearance } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $8C5kA.default)();
    const compact = appearance === 'compact-list';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    const apolloClient = (0, $7hXu9.useApolloClient)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [star, { error: starError }] = (0, $1KmJq.useMutation)($04fcbb12dec9cb03$var$StarButtonPageCardStarMutation);
    const [unstar, { error: unstarError }] = (0, $1KmJq.useMutation)($04fcbb12dec9cb03$var$StarButtonPageCardUnstarMutation);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                attributes: {
                    type: type
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        type
    ]);
    const modifyStarCache = (0, $42omo.useCallback)(({ newStarredValue: newStarredValue, useAggClient: useAggClient = false })=>{
        // SpacePages underlying queries are migrating to AGG, before these mutations switch over,
        // so we need to manually modify the AGG client cache to ensure stateful UI updates.
        // Once the mutations switch over, we could remove this logic.
        const client = useAggClient ? (0, $gKr8t.getAGGClient)() : apolloClient;
        const capitalizedType = (0, $b6404efbbcc25998$export$caa6fc1b5639be76)(type);
        const dataTypename = `Confluence${capitalizedType}`;
        // The PageCardStar/PageCardUnstar mutations do not return the updated viewer data, so we need to manually update the cache.
        // This is necessary to update the UI immediately after the user clicks the star button.
        client.writeFragment({
            id: `${dataTypename}:${(0, $gw4Eo.getConfluenceContentAri)({
                siteId: cloudId,
                resourceType: type,
                activationId: activationId,
                resourceId: id
            })}`,
            fragment: (0, $b6404efbbcc25998$export$81b167aa686d9284)(type),
            data: {
                viewer: {
                    favoritedSummary: {
                        isFavorite: newStarredValue,
                        __typename: 'ConfluenceFavoritedSummary'
                    },
                    __typename: `Confluence${capitalizedType}ViewerSummary`
                },
                __typename: dataTypename
            }
        });
    }, [
        id,
        type,
        activationId,
        apolloClient,
        cloudId
    ]);
    const isActivityV3RecentsEnabled = (0, $li6DS.getIsActivityV3RecentsEnabled)();
    const onStarClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        star({
            variables: {
                id: id
            },
            optimisticResponse: {
                favouritePage: {
                    __typename: 'FavouritePagePayload',
                    content: {
                        __typename: 'Content',
                        id: id,
                        metadata: {
                            __typename: 'ContentMetadata',
                            currentuser: {
                                __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                                favourited: {
                                    __typename: 'FavouritedSummary',
                                    isFavourite: true
                                }
                            }
                        }
                    }
                }
            }
        });
        sendAnalyticsEvent('created');
        (0, $9wGTI.fg)('cc-agg-migration_space-pages-to-agg') && modifyStarCache({
            newStarredValue: true,
            useAggClient: true
        });
        isActivityV3RecentsEnabled && modifyStarCache({
            newStarredValue: true
        });
    }, [
        star,
        id,
        sendAnalyticsEvent,
        modifyStarCache,
        isActivityV3RecentsEnabled
    ]);
    const onUnstarClick = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        unstar({
            variables: {
                id: id
            },
            optimisticResponse: {
                unfavouritePage: {
                    __typename: 'FavouritePagePayload',
                    content: {
                        __typename: 'Content',
                        id: id,
                        metadata: {
                            __typename: 'ContentMetadata',
                            currentuser: {
                                __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                                favourited: null
                            }
                        }
                    }
                }
            }
        });
        sendAnalyticsEvent('deleted');
        (0, $9wGTI.fg)('cc-agg-migration_space-pages-to-agg') && modifyStarCache({
            newStarredValue: false,
            useAggClient: true
        });
        isActivityV3RecentsEnabled && modifyStarCache({
            newStarredValue: false
        });
    }, [
        unstar,
        id,
        sendAnalyticsEvent,
        modifyStarCache,
        isActivityV3RecentsEnabled
    ]);
    const tooltipLabel = isStarred ? intl.formatMessage($04fcbb12dec9cb03$var$i18n.unstar) : intl.formatMessage($04fcbb12dec9cb03$var$i18n.star);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: unstarError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipLabel,
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
        id: `star-button-${id}`,
        spacing: compact ? 'compact' : 'default',
        appearance: "subtle",
        onClick: onUnstarClick,
        "aria-label": intl.formatMessage($04fcbb12dec9cb03$var$i18n.star),
        "aria-pressed": isStarred,
        "aria-labelledby": `star-button-${id} content-title-${id}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bvJMy.StarSelectedIcon), {
            label: ""
        }),
        testId: "page-unstar-button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
        id: `star-button-${id}`,
        spacing: compact ? 'compact' : 'default',
        appearance: "subtle",
        onClick: onStarClick,
        "aria-label": intl.formatMessage($04fcbb12dec9cb03$var$i18n.star),
        "aria-pressed": isStarred,
        "aria-labelledby": `star-button-${id} content-title-${id}`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
            label: ""
        }),
        testId: "page-star-button"
    })))));
};











var $8cjip = parcelRequire("8cjip");


var $fCjCI = parcelRequire("fCjCI");





var $4c4ke = parcelRequire("4c4ke");


var $5EoFB = parcelRequire("5EoFB");


var $bl4QJ = parcelRequire("bl4QJ");












var $7tW57 = parcelRequire("7tW57");

const $ac97a98bde54329f$export$8091e3849c182a6 = (menuItem, isSelected)=>{
    const { setIsMenuOpen: setIsMenuOpen, setSelectedMenuItems: setSelectedMenuItems, selectedMenuItems: selectedMenuItems } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    (0, $42omo.useEffect)(()=>{
        setSelectedMenuItems({
            ...selectedMenuItems,
            [menuItem]: isSelected
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelected
    ]);
    (0, $42omo.useEffect)(()=>{
        if (selectedMenuItems[(0, $7tW57.QuickActionsEnum).WatchButton] || selectedMenuItems[(0, $7tW57.QuickActionsEnum).ShareButton]) setIsMenuOpen(true);
        else setIsMenuOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedMenuItems
    ]);
};








const $c75091fbd7089ca4$var$i18n = (0, $cgtv4.defineMessages)({
    watch: {
        id: "page-card.quick-actions.watch.page",
        defaultMessage: "Watch"
    },
    unwatch: {
        id: "page-card.quick-actions.unwatch.page",
        defaultMessage: "Unwatch"
    },
    watchLabel: {
        id: "page-card.quick-actions.watch.aria-label",
        defaultMessage: "Watch {title}"
    },
    unwatchLabel: {
        id: "page-card.quick-actions.unwatch.aria-label",
        defaultMessage: "Unwatch {title}"
    }
});
const $c75091fbd7089ca4$export$41b9225b77f84823 = ({ isWatching: isWatching, isSelected: isSelected, triggerProps: triggerProps, onClick: onClick, onMouseOver: onMouseOver })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jsaQN.usePageCardAnalyticsEvents)();
    (0, $ac97a98bde54329f$export$8091e3849c182a6)((0, $7tW57.QuickActionsEnum).WatchButton, isSelected);
    const { type: type, appearance: appearance, title: title } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const intl = (0, $8C5kA.default)();
    const compact = appearance === 'compact-list';
    const [Icon, label, ariaLabel] = isWatching ? [
        (0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))),
        intl.formatMessage($c75091fbd7089ca4$var$i18n.unwatch),
        intl.formatMessage($c75091fbd7089ca4$var$i18n.unwatchLabel, {
            title: title.text
        })
    ] : [
        (0, (/*@__PURE__*/$parcel$interopDefault($8cjip))),
        intl.formatMessage($c75091fbd7089ca4$var$i18n.watch),
        intl.formatMessage($c75091fbd7089ca4$var$i18n.watchLabel, {
            title: title.text
        })
    ];
    const handleWatchClick = (0, $42omo.useCallback)(()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'content-watch-button',
                attributes: {
                    contentType: type
                }
            }
        }).fire();
    }, [
        onClick,
        createAnalyticsEvent,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: label,
        position: "top",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9435f53888e733e2$export$3c1d9e6f68d6384d), {
        spacing: compact ? 'compact' : 'default',
        appearance: "subtle",
        onClick: handleWatchClick,
        onMouseOver: onMouseOver,
        isSelected: isSelected,
        "aria-label": ariaLabel,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: ""
        }),
        ...triggerProps || {}
    })));
};
const $c75091fbd7089ca4$export$e149a93a7ac7f896 = ()=>{
    const { id: id, appearance: appearance, isViewed: isViewed } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const compact = appearance === 'compact-list';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, isViewed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4c4ke.WatchDialog), {
        contentId: id,
        defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
        customTrigger: $c75091fbd7089ca4$export$41b9225b77f84823,
        useShortcut: false,
        compact: compact
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bl4QJ.WatchButtonPlaceholder), {
        compact: compact
    }));
};






var $hkzol = parcelRequire("hkzol");





const $6e589e112b83e5ab$export$534d10f1c5b9c7b3 = (_)=>{
    const { id: contentId, type: contentType, space: space, analyticsData: analyticsData } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $146c0ee07cc94a7d$export$37ab3bdebc286ca), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: space?.spaceKey ?? '',
        source: analyticsData?.source ?? '',
        buttonAppearance: "subtle",
        tooltipPosition: "top"
    }));
};


const $7f1b580bd70ac23d$export$e53fea40f770c4e5 = /*#__PURE__*/ (0, $42omo.createContext)({
    hidden: true
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7f1b580bd70ac23d$var$QuickActionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1e0c1txw _4cvr1h6o",
            __cmplp.compact ? "_1bahesu3" : "_1bahn7od",
            __cmplp.className
        ])
    });
});
const $7f1b580bd70ac23d$var$QuickActionsListItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $7f1b580bd70ac23d$var$PlaceholderAction = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbzwfg _19pkidpf",
            __cmplp.compact ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $7f1b580bd70ac23d$var$defaultActions = [
    'edit',
    'copy',
    'watch',
    'star'
];
const $7f1b580bd70ac23d$var$useEnabledActions = ()=>{
    const isStarringEnabledForDatabases = (0, $2cKGu.useIsStarringEnabled)('database');
    const isWatchingWhiteboardsEnabled = (0, $3dPSK.useIsWatchDialogEnabled)('whiteboard');
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { status: status, type: type, subType: subType } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    if (!isLicensed || status === 'draft') return [];
    const contentActions = [
        'star'
    ];
    const watchAction = [
        'watch'
    ];
    const livePageActions = $7f1b580bd70ac23d$var$defaultActions.filter((item)=>item !== 'edit');
    const typeActionMap = {
        page: {
            none: $7f1b580bd70ac23d$var$defaultActions,
            live: livePageActions
        },
        blogpost: {
            none: $7f1b580bd70ac23d$var$defaultActions
        },
        whiteboard: {
            none: [
                ...contentActions,
                ...isWatchingWhiteboardsEnabled ? watchAction : []
            ]
        },
        database: {
            none: isStarringEnabledForDatabases ? contentActions : []
        },
        embed: {
            none: contentActions
        },
        folder: {
            none: contentActions
        }
    };
    return typeActionMap[type]?.[subType ?? 'none'] || [];
};
const $7f1b580bd70ac23d$export$626874e33f1a0310 = ({ actions: actions = $7f1b580bd70ac23d$var$defaultActions, hidden: hidden, compact: compact })=>{
    const enabledActions = $7f1b580bd70ac23d$var$useEnabledActions();
    const numberOfPlaceholders = $7f1b580bd70ac23d$var$defaultActions.length - enabledActions.length;
    const quickActionsContextValue = (0, $42omo.useMemo)(()=>({
            hidden: Boolean(hidden)
        }), [
        hidden
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$export$e53fea40f770c4e5.Provider, {
        value: quickActionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$var$QuickActionsContainer, {
        compact: compact
    }, Array(numberOfPlaceholders).fill(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$var$PlaceholderAction, {
        compact: compact
    })), actions.map((action)=>{
        let actionButton = null;
        switch(enabledActions.includes(action) ? action : null){
            case 'edit':
                actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cea5a5dbb111468f$export$a8d3280cb45e38b8), {
                    key: action
                });
                break;
            case 'copy':
                actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6e589e112b83e5ab$export$534d10f1c5b9c7b3), {
                    key: action
                });
                break;
            case 'watch':
                actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c75091fbd7089ca4$export$e149a93a7ac7f896), {
                    key: action
                });
                break;
            case 'star':
                actionButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04fcbb12dec9cb03$export$b4b5678234ca6d4d), {
                    key: action
                });
                break;
            default:
                actionButton = null;
        }
        return actionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7f1b580bd70ac23d$var$QuickActionsListItem, {
            key: action
        }, actionButton) : null;
    })));
};


var $fROKr = parcelRequire("fROKr");

var $eSkJX = parcelRequire("eSkJX");

var $63k9q = parcelRequire("63k9q");


var $4xawV = parcelRequire("4xawV");

const $838b83bb70ba05a9$var$listCardStyle = null;
const $838b83bb70ba05a9$var$gridTemplateColumnsMap = {
    FULL: '32px minmax(300px, 2fr) 1fr 1fr 128px',
    NO_LAST_ACTION: '32px minmax(300px, 2fr) 1fr 0fr 128px',
    NO_SUBTITLE: '32px minmax(300px, 2fr) 0fr 0fr 128px'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$StyledCard = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $dDr80.Card), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itia51 _2rkoidpf _n7zlglyw _16qsglyw _1dbzglyw _irr3ysee _1vjwazsu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$ContentIconContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwxpxbi _4t3i7vkz _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$RoundedCornerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_x5031mok _1snx1mok",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const $838b83bb70ba05a9$var$EmojiWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$TitleText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $838b83bb70ba05a9$var$statusContainerStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $838b83bb70ba05a9$var$SubtitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $838b83bb70ba05a9$var$LastActionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $838b83bb70ba05a9$export$f9e5c039a4efefae = ()=>{
    // ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
    const { width: width } = (0, $42omo.useContext)((0, $4xawV.PageCardsContext));
    let breakPoint = 'FULL';
    if (width < 700) breakPoint = 'NO_SUBTITLE';
    else if (width < 900) breakPoint = 'NO_LAST_ACTION';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$RoundedCornerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
        StyledCard: $838b83bb70ba05a9$var$StyledCard,
        isListitem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), {
        compact: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            gridTemplateColumns: $838b83bb70ba05a9$var$gridTemplateColumnsMap[breakPoint]
        },
        "data-testid": "page-card-compact-list-view",
        className: (0, $gMc0m.default)([
            "_1yt41pyq _1ul9idpf _1e0c11p5 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$ContentIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), {
        wrapper: $838b83bb70ba05a9$var$EmojiWrapper
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$TitleText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
        singleLine: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $838b83bb70ba05a9$var$statusContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$SubtitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($838b83bb70ba05a9$var$LastActionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
        hidden: true,
        compact: true
    }))));
};


var $kzTi3 = parcelRequire("kzTi3");
/* GridView.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1s5hv = parcelRequire("1s5hv");




var $gETnG = parcelRequire("gETnG");







var $1R1bQ = parcelRequire("1R1bQ");







// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$GridCard = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41xcl _1e0c1txw _2lx21bp4 _4t3i1pm2 _1bsb1kdh _c71lgx0z",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$TitleContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81f27 _11c8lodh _1reo15vq _18m915vq _1bto1l2s _1i4q1hna _1e0ccj1k _1yyjcs5v _sudp1e54",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$FooterContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1e0c1txw _4cvresu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f8c933d272d979$var$Footer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _19pkpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $87f8c933d272d979$export$5a87d90ca5d04034 = ()=>{
    // ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
        isListitem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$GridCard, {
        "data-testid": "page-card-grid-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
        hidden: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), {
        isInColumn: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gETnG.Excerpt), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f8c933d272d979$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1R1bQ.SocialProof), null)))));
};

/* ListView.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bUlM5 = parcelRequire("bUlM5");





















'use no memo';
const $089b4dc59c13daf7$var$listCardStylesNav3 = null;
const $089b4dc59c13daf7$var$listCardStyles = null;
const $089b4dc59c13daf7$var$titleContainerNav3Styles = null;
const $089b4dc59c13daf7$var$titleContainerStyles = null;
const $089b4dc59c13daf7$var$contentIconStylesNav3 = null;
const $089b4dc59c13daf7$var$contentIconStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $089b4dc59c13daf7$var$MainContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlgrho _1wpz1y6m _1ul91mjv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $089b4dc59c13daf7$var$TitleText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2hwxu2gc _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $089b4dc59c13daf7$var$lastActionContainerStylesNav3 = (0, $ecnYn.xcss)({
    minWidth: '100px',
    flex: '0 1 300px'
});
const $089b4dc59c13daf7$var$lastActionContainerStyles = null;
const $089b4dc59c13daf7$export$84d0dd190d551cd1 = ()=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)(); // ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dDr80.PageCardContainer), {
        isListitem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CEYG.PageLink), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "page-card-list-view",
        className: (0, $gMc0m.default)([
            isNav4Enabled ? "_1yt41pyq _1ul9idpf _1e0c1txw _4cvr1h6o" : "_1yt4pxbi _1ul9idpf _1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isNav4Enabled ? "_18s8plhh _1wpz1y6m" : "_18s811z0 _1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoeyL.ContentIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($089b4dc59c13daf7$var$MainContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isNav4Enabled ? "_1e0c1txw _4cvr1h6o" : "_1e0c1txw _4cvr1h6o _otyr1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($089b4dc59c13daf7$var$TitleText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63k9q.Title), {
        singleLine: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fROKr.StatusLozenge), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eSkJX.Subtitle), null)), isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
        hidden: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wdt _1ul953f4 _y3gnusic"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), {
        appearance: "list"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $089b4dc59c13daf7$var$lastActionContainerStylesNav3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9Olr.LastAction), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7f1b580bd70ac23d$export$626874e33f1a0310), {
        hidden: true
    }))));
};


var $dDu9z = parcelRequire("dDu9z");


var $jb4sa = parcelRequire("jb4sa");

const $53e35d7d38738d3f$var$getViewComponent = (appearance)=>{
    switch(appearance){
        case 'grid':
            return 0, $87f8c933d272d979$export$5a87d90ca5d04034;
        case 'list':
            return 0, $089b4dc59c13daf7$export$84d0dd190d551cd1;
        case 'compact-list':
            return 0, $838b83bb70ba05a9$export$f9e5c039a4efefae;
        case 'popup-view':
            return 0, $dDu9z.PopupView;
        case 'end-of-page':
            return 0, $kzTi3.EndOfPageView;
        case 'compact-end-of-page':
            return 0, $kzTi3.EndOfPageView;
    }
};
const $53e35d7d38738d3f$export$832e93955c36efe9 = (wrapperProps)=>{
    const View = $53e35d7d38738d3f$var$getViewComponent(wrapperProps.appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jb4sa.PageCardContextProvider), wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(View, null));
};





'use no memo';
const $18632bf01698551b$var$pageCardConainerStylesNav3 = {
    grid: "_zulppxbi _1e0c11p5 _1ul9aq3k _p12f1bp9 _yv0e93b1",
    list: "_1e0c1txw _2lx21bp4 _1ul91ogm _t5egu2gc",
    'compact-list': "_a0x01txw _2lx21bp4 _1ul91ogm _1x5514xi _1odi8p36 _ip6eia51"
};
const $18632bf01698551b$var$pageCardConainerStyles = {
    grid: "_zulppxbi _1e0c11p5 _1ul9aq3k _p12f1bp9 _yv0e93b1",
    list: "_1e0c1txw _2lx21bp4 _1ul91ogm _1g96idpf _1fuqglyw _17wxglyw _1nb4ysee _1c2cazsu _1s7w1tqt _1s5uglyw _1n3wb0je _yeslia51",
    'compact-list': ""
};
const $18632bf01698551b$export$a92f8045b239279b = ({ appearance: appearance, nodes: nodes, analyticsData: analyticsData })=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setWidth, 200, {
        leading: false
    });
    const pageCardsContextValue = (0, $42omo.useMemo)(()=>({
            width: width
        }), [
        width
    ]);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4xawV.PageCardsContext).Provider, {
        value: pageCardsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "list",
        className: (0, $gMc0m.default)([
            isNav4Enabled && $18632bf01698551b$var$pageCardConainerStyles[appearance],
            !isNav4Enabled && $18632bf01698551b$var$pageCardConainerStylesNav3[appearance]
        ])
    }, nodes.map((node, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53e35d7d38738d3f$export$832e93955c36efe9), {
            appearance: appearance,
            data: node,
            key: node.key || node.id,
            ranking: i,
            analyticsData: analyticsData
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.WidthObserver), {
        setWidth: onResize,
        offscreen: true
    })));
};
module.exports["PageCards"] = $18632bf01698551b$export$a92f8045b239279b;

});

parcelRegister("lBLrW", function(module, exports) {
/* PageCardAppearanceToggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");








var $aaEXZ = parcelRequire("aaEXZ");

const $fb6e993b302714b6$export$e6090e20fb1e56e9 = (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaEXZ))), {
        label: label,
        color: primaryColor,
        spacing: "spacious",
        testId: props.testId
    });
};


const $892d154fe52aa703$export$f0f500e4832f7ca4 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb6e993b302714b6$export$e6090e20fb1e56e9), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};








var $dk0le = parcelRequire("dk0le");

const $0471bf2ec075209c$export$3570ac4c3e881cb1 = (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dk0le))), {
        color: primaryColor,
        spacing: "spacious",
        label: label,
        testId: props.testId
    });
};


const $f1bed3656a6df92d$export$fa17e9a974485717 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0471bf2ec075209c$export$3570ac4c3e881cb1), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};








var $ai9UQ = parcelRequire("ai9UQ");

const $0bd5fe9912278910$export$4c9b65bdcf92ad22 = (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #292A2E)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ai9UQ))), {
        label: label,
        color: primaryColor,
        spacing: "spacious",
        testId: props.testId
    });
};


const $781dc60d1c0744fb$export$230671d7ba50d3c8 = ({ label: label, primaryColor: primaryColor, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0bd5fe9912278910$export$4c9b65bdcf92ad22), {
        label: label,
        testId: testId,
        primaryColor: primaryColor
    });
};



var $gz8ZY = parcelRequire("gz8ZY");

/* PageCardAppearanceOption.tsx generated by @compiled/babel-plugin v0.36.1 */ 





'use no memo';
const $83cf45b7dcdaab8f$var$inputStyle = null;
const $83cf45b7dcdaab8f$var$baseLabelStyle = null;
const $83cf45b7dcdaab8f$var$hoverAndFocusStyle = null;
const $83cf45b7dcdaab8f$var$selectedHoverAndFocusStyles = null;
const $83cf45b7dcdaab8f$var$disabledStyle = null;
const $83cf45b7dcdaab8f$export$38dfdd608e2cb4f4 = ({ isChecked: isChecked, onClick: onClick, ToggleIcon: ToggleIcon, disabled: disabled = false, label: label })=>{
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const toggleFocus = (0, $42omo.useCallback)(()=>{
        setIsFocused(!isFocused);
    }, [
        isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("label", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _ae4v1h6o _1bah1h6o _1e0c1txw _80omtlke _4cvr1h6o",
            disabled && "_80om13gf",
            isChecked && !disabled ? "_1e387g83 _19h6fajl _7glxidpf _irr3ysee" : "_irr3ysee"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "radio",
        name: "project-type-selection",
        checked: isChecked,
        onClick: onClick,
        onFocus: toggleFocus,
        onBlur: toggleFocus,
        "aria-checked": isChecked,
        "aria-label": label,
        disabled: disabled,
        className: (0, $gMc0m.default)([
            "_kqswstnw _tzy4idpf _lcxvglyw _4t3i1ejb _1bsb1ejb"
        ])
    }), ToggleIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ToggleIcon, {
        size: "medium",
        primaryColor: !disabled && isChecked ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)"
    }));
};


const $f25b105f04129604$var$toggleContainerStyles = null;
const $f25b105f04129604$var$i18n = (0, $cgtv4.defineMessages)({
    cardView: {
        id: "page-card.toggle.card-view",
        defaultMessage: "Cards"
    },
    listView: {
        id: "page-card.toggle.list-view",
        defaultMessage: "List"
    },
    compactListView: {
        id: "page-card.toggle.compact-list-view",
        defaultMessage: "Compact list"
    },
    radioGroupLabel: {
        id: "page-card.toggle.radio-group-label",
        defaultMessage: "Appearance"
    }
});
const $f25b105f04129604$export$ff902e0e5a0ce993 = ({ appearance: appearance, setAppearance: setAppearance, disabled: disabled, order: order = [
    'grid',
    'list',
    'compact-list'
], source: source })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)(); // Conditionally remove 'compact-list' if nav4 is enabled
    const filteredOrder = isNav4Enabled ? order.filter((view)=>view !== 'compact-list') : order;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const onClick = (appearance)=>{
        if (disabled) return;
        setAppearance(appearance);
        const actionSubjectId = appearance === 'grid' ? 'cards' : 'list';
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: actionSubjectId
            }
        }).fire();
    };
    const toggles = {
        grid: {
            id: 'grid',
            i18n: $f25b105f04129604$var$i18n.cardView,
            icon: (0, $f1bed3656a6df92d$export$fa17e9a974485717)
        },
        list: {
            id: 'list',
            i18n: $f25b105f04129604$var$i18n.listView,
            icon: (0, $781dc60d1c0744fb$export$230671d7ba50d3c8)
        },
        'compact-list': {
            id: 'compact-list',
            i18n: $f25b105f04129604$var$i18n.compactListView,
            icon: (0, $892d154fe52aa703$export$f0f500e4832f7ca4)
        },
        'popup-view': null,
        'end-of-page': null,
        'compact-end-of-page': null
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul" // eslint-disable-next-line @atlassian/a11y/no-noninteractive-element-to-interactive-role, @atlassian/a11y/role-has-required-aria-props
    , {
        role: "radiogroup",
        "aria-label": intl.formatMessage($f25b105f04129604$var$i18n.radioGroupLabel),
        className: (0, $gMc0m.default)([
            "_zulp1b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c116y _2lx2vrvc _4cvr1h6o _2mzuglyw _1bah1h6o"
        ])
    }, filteredOrder.map((t)=>{
        const toggle = toggles[t];
        const ToggleIcon = toggle?.icon;
        return toggle && ToggleIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: toggle.id,
            content: intl.formatMessage(toggle.i18n),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            key: toggle.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $83cf45b7dcdaab8f$export$38dfdd608e2cb4f4), {
            onClick: ()=>onClick(toggle.id),
            isChecked: appearance === toggle.id,
            ToggleIcon: ToggleIcon,
            disabled: disabled,
            label: intl.formatMessage(toggle.i18n)
        })));
    }));
};
const $f25b105f04129604$export$dc05e76bf044b54 = (defaultAppearance = 'grid')=>{
    const [appearance, setAppearance] = (0, $42omo.useState)(defaultAppearance);
    return {
        appearance: appearance,
        setAppearance: setAppearance
    };
};
module.exports["PageCardAppearanceToggle"] = $f25b105f04129604$export$ff902e0e5a0ce993;

});

parcelRegister("2mfTa", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");


var $ctLrB = parcelRequire("ctLrB");

const $cfb387504b3ebb46$var$getLastActionFromRecent = (recent, isActivityV3HomeRecent)=>{
    const timestamp = isActivityV3HomeRecent ? recent.event?.timestamp || '' : recent.timestamp || '';
    const recentAction = isActivityV3HomeRecent ? recent.event?.eventType : recent.object?.events?.[0].eventType;
    let action;
    switch(recentAction){
        case (0, $ctLrB.ActivityEventType).COMMENTED:
            action = 'commented';
            break;
        case (0, $ctLrB.ActivityEventType).EDITED:
        case (0, $ctLrB.ActivityEventType).UPDATED:
        case (0, $ctLrB.ActivityEventType).PUBLISHED:
        case (0, $ctLrB.ActivityEventType).SNAPSHOTTED:
            action = 'edited';
            break;
        case (0, $ctLrB.ActivityEventType).CREATED:
        case (0, $ctLrB.ActivityEventType).STARTED:
            action = 'createdByYou';
            break;
        case (0, $ctLrB.ActivityEventType).VIEWED:
            action = 'visited';
            break;
        case (0, $ctLrB.ActivityEventType).LIKED:
            action = 'liked';
            break;
    }
    return {
        when: timestamp,
        action: action
    };
};
const $cfb387504b3ebb46$export$b3035d9add269629 = (recent, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false, isActivityV3HomeRecent = false)=>{
    const content = isActivityV3HomeRecent ? recent.object?.data : recent.object?.content;
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        // Using ConfluencePage to fix type error caused by ConfluenceFooterComment not having id in the types file
        key: isActivityV3HomeRecent ? `${content?.id}-${recent?.event?.eventType}` : `${content?.id}-${recent.object?.events?.[0].eventType}`,
        lastAction: $cfb387504b3ebb46$var$getLastActionFromRecent(recent, isActivityV3HomeRecent)
    };
};
const $cfb387504b3ebb46$export$9630855043012801 = (created, untitledDraftText = '', userId = null)=>{
    const id = created?.content?.id || '';
    const content = created?.content;
    const isContentCreatedByCurrentUser = (0, $ctLrB.isCreatorCurrentUser)(userId, content);
    const actionText = !isContentCreatedByCurrentUser ? 'ownedByYou' : 'createdByYou';
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText),
        key: `${id}-created`,
        lastAction: {
            when: created.content?.metadata.createdDate || '',
            action: actionText
        }
    };
};
const $cfb387504b3ebb46$export$9e542ec8039a0bcd = (draft, untitledDraftText = '')=>{
    const content = draft?.content;
    const id = content?.id || '';
    return {
        ...(0, $cxMI6.transformGlobalContent)(content, untitledDraftText),
        key: `${id}-draft`,
        lastAction: {
            when: content?.metadata.lastModifiedDate || '',
            action: 'edited'
        }
    };
};
const $cfb387504b3ebb46$export$7d474971357ff1a1 = (data, untitledDraftText = '')=>{
    return {
        ...(0, $cxMI6.transformGlobalContent)(data, untitledDraftText),
        lastAction: {
            when: data?.metadata.currentuser?.viewed?.lastSeen || data?.history?.lastUpdated?.when || '',
            action: data?.metadata.currentuser?.viewed?.lastSeen ? 'visited' : 'updated'
        }
    };
};
module.exports["transformRecentToPageCard"] = $cfb387504b3ebb46$export$b3035d9add269629;
module.exports["transformCreatedByMeToPageCard"] = $cfb387504b3ebb46$export$9630855043012801;
module.exports["transformDraftToPageCard"] = $cfb387504b3ebb46$export$9e542ec8039a0bcd;
module.exports["transformStarredToPageCard"] = $cfb387504b3ebb46$export$7d474971357ff1a1;

});

parcelRegister("288YL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $7p4As = parcelRequire("7p4As");


var $dkIiA = parcelRequire("dkIiA");


var $bZSO8 = parcelRequire("bZSO8");


var $gTyTP = parcelRequire("gTyTP");

const $c299cfa438844b48$var$i18n = (0, $cgtv4.defineMessages)({
    createPage: {
        id: "home.home-views.create-page",
        defaultMessage: "Create a page"
    },
    createLivePage: {
        id: "home.home-views.create-live-doc",
        defaultMessage: "Create a live doc"
    }
});
const $c299cfa438844b48$export$305e51f590235bd4 = ({ appearance: appearance, creationLinkSource: creationLinkSource, showCreateLivePageButton: showCreateLivePageButton })=>{
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const creationHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: creationLinkSource,
        withFallback: true,
        subType: isLivePagesFeatureEnabled ? (0, $dkIiA.ConfluencePageSubType).LIVE : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: creationHref,
        appearance: appearance,
        shouldFitContainer: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), showCreateLivePageButton && isLivePagesFeatureEnabled ? $c299cfa438844b48$var$i18n.createLivePage : $c299cfa438844b48$var$i18n.createPage));
};
module.exports["CreatePageButton"] = $c299cfa438844b48$export$305e51f590235bd4;

});

parcelRegister("8VNSW", function(module, exports) {
/* Options.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $4noo5 = parcelRequire("4noo5");


var $jluld = parcelRequire("jluld");


var $inPa6 = parcelRequire("inPa6");


var $6F6hl = parcelRequire("6F6hl");


var $lBLrW = parcelRequire("lBLrW");


var $b3j2Y = parcelRequire("b3j2Y");


var $ktNBJ = parcelRequire("ktNBJ");


var $lXXa4 = parcelRequire("lXXa4");

const $6517be26292f0fb8$var$i18n = (0, $cgtv4.defineMessages)({
    textFilterPlaceholder: {
        id: "home.views.recent.options.placeholder",
        defaultMessage: "Filter by title"
    },
    textFilterDescription: {
        id: "home.views.recent.options.filter.description",
        defaultMessage: "Results will update as you type."
    },
    filteredResultsCount: {
        id: "home.views.recent.filtered-results-announcement",
        defaultMessage: "{count, plural, one {# result} other {# results}} found"
    }
});
const $6517be26292f0fb8$var$optionsContainerStyles = null;
const $6517be26292f0fb8$var$optionsLeftStyles = null;
const $6517be26292f0fb8$export$c019608e5b5bb4cb = ({ appearance: appearance, setAppearance: setAppearance, filterText: filterText, setFilterText: setFilterText, pill: pill, setPill: setPill, pills: pills, loading: loading, queryError: queryError, mutationError: mutationError, pageCardDataLength: pageCardDataLength })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSearchChange = (0, $42omo.useCallback)((e)=>{
        const text = e.currentTarget.value;
        setFilterText(text);
    }, [
        setFilterText
    ]);
    const onClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${selectedView}Screen`,
                action: 'clicked',
                actionSubject: 'textField',
                actionSubjectId: `${selectedView}ScreenSearchBar`
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        selectedView
    ]);
    const placeholder = formatMessage($6517be26292f0fb8$var$i18n.textFilterPlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _otyrxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        placeholder: placeholder,
        "aria-label": placeholder,
        defaultValue: filterText,
        isCompact: true,
        width: "medium",
        onChange: onSearchChange,
        onClick: onClick,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            label: "",
            spacing: "spacious"
        }),
        "aria-describedby": "filterByTitleDescription"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        id: "filterByTitleDescription",
        role: "status"
    }, filterText !== '' ? formatMessage($6517be26292f0fb8$var$i18n.filteredResultsCount, {
        count: pageCardDataLength
    }) : formatMessage($6517be26292f0fb8$var$i18n.textFilterDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lXXa4.Pills), {
        pill: pill,
        setPill: setPill,
        pills: pills
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBLrW.PageCardAppearanceToggle), {
        appearance: appearance,
        setAppearance: setAppearance,
        disabled: loading,
        source: `${selectedView}Screen`
    }), queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
};
module.exports["Options"] = $6517be26292f0fb8$export$c019608e5b5bb4cb;

});

parcelRegister("lXXa4", function(module, exports) {
/* Pills.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $ktNBJ = parcelRequire("ktNBJ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4342bec3f656d280$var$PillsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bv1ejb _1e0c1txw _4cvr1h6o _u5f3pxbi",
            __cmplp.className
        ])
    });
});
const $4342bec3f656d280$var$PillButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _11c82smr _1yt4u2gc _2rko1rr0 _vchhusvi _1e0c116y _80omtlke _uiztglyw _o5721q9c _s7n4jp4b _18u0u2gc _4t3izwfg _1bah1h6o _4cvr1h6o _1ul9ckbl _11cpidpf _y2mv7g83 _858u1j28",
            __cmplp.isSelected ? "_bfhk15s3" : "_bfhki8nm",
            __cmplp.isSelected ? "_syaz6x5g" : "_syazi7uo",
            __cmplp.isSelected ? "_irr3ufnl" : "_irr3plhp",
            __cmplp.isSelected ? "_19it188o" : "_19it1tra",
            __cmplp.className
        ])
    });
});
const $4342bec3f656d280$export$93f0733b9cd7cb26 = ({ pill: pill, setPill: setPill, pills: pills })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const selectedView = (0, $ktNBJ.useSelectedView)();
    const onClick = (pillButton)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${selectedView}Screen`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: pillButton.name
            }
        }).fire();
        setPill && setPill(pillButton.name);
    };
    return pills ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4342bec3f656d280$var$PillsContainer, {
        role: "tablist"
    }, pills.map((pillButton)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4342bec3f656d280$var$PillButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: "select-task-view",
            key: pillButton.name,
            isSelected: pillButton.name === pill,
            onClick: ()=>onClick(pillButton),
            role: "tab",
            "aria-selected": pillButton.name === pill
        }, pillButton.i18n))) : null;
};
module.exports["Pills"] = $4342bec3f656d280$export$93f0733b9cd7cb26;

});

parcelRegister("92U9l", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");

/**
 * @generated SignedSource<<66916e210ca6f19e9cfa05732a5ca031>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4d40ef7fe2ee284$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useHomeViewsUserPreferencesFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "homePagesDisplayView"
        }
    ],
    "type": "UserPreferences"
};
$f4d40ef7fe2ee284$var$node.hash = "3fe421033dfe27b25540bf65e36d452b";
var $f4d40ef7fe2ee284$export$2e2bcd8739ae039 = $f4d40ef7fe2ee284$var$node;






var $7hXu9 = parcelRequire("7hXu9");

var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");


var $6mKj3 = parcelRequire("6mKj3");


var $ij4CE = parcelRequire("ij4CE");





var $iNq0h = parcelRequire("iNq0h");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d42cf02d09d887b5$export$e7cf5ba3dce96e2a = /*#__PURE__*/ function(PagesDisplayPersistenceOption) {
    PagesDisplayPersistenceOption["CARDS"] = "CARDS";
    PagesDisplayPersistenceOption["COMPACT_LIST"] = "COMPACT_LIST";
    PagesDisplayPersistenceOption["LIST"] = "LIST";
    return PagesDisplayPersistenceOption;
}({});


const $1ace401e96fe65a9$export$d3291c051e5b508d = (defaultPreference = (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const apolloClient = (0, $7hXu9.useApolloClient)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $f4d40ef7fe2ee284$export$2e2bcd8739ae039)
    });
    const { data: data, loading: loading, error: queryError } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $iNq0h.HomeViewsUserPreferencesQuery), {
        skip: !isLoggedIn
    });
    const appearance = data?.userPreferences.homePagesDisplayView || defaultPreference;
    const [homeViewsUserPreferencesMutation, { error: mutationError }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useHomeViewsUserPreferencesHomeViewsUserPreferencesMutation($appearance:PagesDisplayPersistenceOption!){updateUserPreferences(userPreferences:{homePagesDisplayView:$appearance}){homePagesDisplayView}}`);
    const updateHomeViewsUserPreference = (appearance)=>{
        if (isLoggedIn) {
            homeViewsUserPreferencesMutation({
                variables: {
                    appearance: appearance
                },
                optimisticResponse: {
                    // @ts-ignore __typename does not exist on autogenerated graphql types
                    __typename: 'Mutation',
                    updateUserPreferences: {
                        // @ts-ignore __typename does not exist on autogenerated graphql types
                        __typename: 'UserPreferences',
                        homePagesDisplayView: appearance
                    }
                }
            }).catch(()=>{}); // Ignore the error here since it is handled in useMutation
            // Always write to the cache so the user sees the preference even if there is an error
            if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) // Use writeFragmentInterop instead of writeQuery
            writeFragmentInterop({
                fragmentId: '$ROOT_QUERY.userPreferences',
                data: {
                    homePagesDisplayView: appearance,
                    __typename: 'UserPreferences'
                }
            });
            else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            apolloClient.writeQuery({
                query: (0, $iNq0h.HomeViewsUserPreferencesQuery),
                data: {
                    userPreferences: {
                        // @ts-ignore __typename does not exist on autogenerated graphql types
                        __typename: 'UserPreferences',
                        homePagesDisplayView: appearance
                    }
                }
            });
        }
    };
    return {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        appearance: appearance,
        updateHomeViewsUserPreference: updateHomeViewsUserPreference
    };
};
const $1ace401e96fe65a9$export$53a53a6921472be1 = (defaultPreference = (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS)=>{
    const [appearance, setAppearance] = (0, $42omo.useState)(defaultPreference);
    return {
        loading: false,
        appearance: appearance,
        updateHomeViewsUserPreference: setAppearance
    };
};



const $24342ec75a348aae$var$AppearancePersistenceToToggle = {
    [(0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS]: 'grid',
    [(0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).LIST]: 'list',
    [(0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).COMPACT_LIST]: 'compact-list'
};
const $24342ec75a348aae$var$AppearanceToggleToPersistence = {
    grid: (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS,
    list: (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).LIST,
    'compact-list': (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).COMPACT_LIST,
    'popup-view': (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS,
    'end-of-page': (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS,
    'compact-end-of-page': (0, $d42cf02d09d887b5$export$e7cf5ba3dce96e2a).CARDS
};
const $24342ec75a348aae$export$b8ae39f344200a7d = (pills, defaultPill)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const [filterText, setFilterText] = (0, $42omo.useState)('');
    const [pill, setPill] = (0, $42omo.useState)(defaultPill);
    /**
	 * The default pill will only change if an override from query params changes.
	 * In this case, we need to update the state in order for the UI to reflect
	 * the new pill.
	 */ (0, $42omo.useEffect)(()=>{
        setPill(defaultPill);
    }, [
        defaultPill
    ]);
    const loggedInUserPreferences = (0, $1ace401e96fe65a9$export$d3291c051e5b508d)();
    const anonymousUserPreferences = (0, $1ace401e96fe65a9$export$53a53a6921472be1)();
    const { loading: loading, queryError: queryError, mutationError: mutationError, appearance: appearance, updateHomeViewsUserPreference: updateHomeViewsUserPreference } = isLoggedIn ? loggedInUserPreferences : anonymousUserPreferences;
    const setAppearance = (appearance)=>{
        updateHomeViewsUserPreference($24342ec75a348aae$var$AppearanceToggleToPersistence[appearance]);
    };
    const optionsData = {
        loading: loading,
        queryError: queryError,
        mutationError: mutationError,
        filterText: filterText,
        setFilterText: setFilterText,
        appearance: $24342ec75a348aae$var$AppearancePersistenceToToggle[appearance],
        setAppearance: setAppearance
    };
    if (pills) {
        optionsData.pill = pill;
        optionsData.pill = pill;
        optionsData.setPill = setPill;
        optionsData.pills = pills;
    }
    return optionsData;
};
module.exports["useOptions"] = $24342ec75a348aae$export$b8ae39f344200a7d;

});

parcelRegister("c2B7a", function(module, exports) {
/* LoadingAndPagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $b3j2Y = parcelRequire("b3j2Y");


var $fLinG = parcelRequire("fLinG");


var $ctLrB = parcelRequire("ctLrB");





var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7hXDW = parcelRequire("7hXDW");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $1NBp8 = parcelRequire("1NBp8");

var $3bef251bc50e9850$exports = {};
$3bef251bc50e9850$exports = new URL("NoResultsImage.ca37f2fe.svg", import.meta.url).toString();


const $2e32c2416bb0a42b$var$NoResultsContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $2e32c2416bb0a42b$export$ef6006467f04ee41 = ({ message: message, subMessage: subMessage, filterText: filterText, source: source, filter: filter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const fireTrackEvent = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: `${source}NoResults`,
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const onSearchClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: `${source}SearchLink`,
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    (0, $42omo.useEffect)(()=>{
        fireTrackEvent();
    }, [
        fireTrackEvent
    ]);
    const hasAdvancedSearchContributorSetting = 'WORKED_ON' === filter;
    const hasAdvancedSearchOwnerSetting = 'CREATED' === filter;
    const searchHref = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
        query: {
            text: filterText,
            ...hasAdvancedSearchContributorSetting && userId && {
                contributors: userId
            },
            ...hasAdvancedSearchOwnerSetting && userId && {
                owners: userId
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2e32c2416bb0a42b$var$NoResultsContainerStyles,
        paddingBlockStart: "space.1000"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3bef251bc50e9850$exports))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.600",
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "small",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), message))), subMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...subMessage,
        values: {
            a: (anchorText)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__disco') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: searchHref,
                    onClick: onSearchClick
                }, anchorText) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
                    href: searchHref,
                    onClick: onSearchClick
                }, anchorText)
        }
    }));
};


/* Empty.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $iXCQx = parcelRequire("iXCQx");


var $gj7hi = parcelRequire("gj7hi");

var $19c42ea63f3ba34c$exports = {};
$19c42ea63f3ba34c$exports = new URL("EmptyStateImageLight.6df2a248.svg", import.meta.url).toString();


const $10e3f67db57b52fe$var$emptyContainerStyles = null;
const $10e3f67db57b52fe$var$emptyHeaderStyles = null;
const $10e3f67db57b52fe$var$emptyBodyStyles = null;
const $10e3f67db57b52fe$var$callToActionStyles = null;
const $10e3f67db57b52fe$var$emptyStateImage = {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($19c42ea63f3ba34c$exports)))
};
const $10e3f67db57b52fe$export$1f74963c34e8bfec = ({ header: header, body: body, image: image = $10e3f67db57b52fe$var$emptyStateImage, callToAction: callToAction })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkxncg _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: image.src,
        srcDark: image.srcDark,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h3", {
        className: (0, $gMc0m.default)([
            "_19pkldb6"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkpxbi _1bsb7ijl _y3gn1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...body,
        values: {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    as: "strong"
                }, chunks)
        }
    })), callToAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkpxbi"
        ])
    }, callToAction));



var $edxGF = parcelRequire("edxGF");

const $0efe97bbc4ecdd1c$var$loadingMoreStyles = null;
const $0efe97bbc4ecdd1c$var$loadingOverlayStyles = null;
const $0efe97bbc4ecdd1c$var$overlaySpinnerContainerStyles = null;
const $0efe97bbc4ecdd1c$export$2a05df71362b48c6 = ({ pageCardDataLength: pageCardDataLength, loading: loading, error: error, hasNextPage: hasNextPage, loadMore: loadMore, noResultsMessage: noResultsMessage, noResultsSubtext: noResultsSubtext, emptyMessageHeader: emptyMessageHeader, emptyMessageBody: emptyMessageBody, emptyMessageImage: emptyMessageImage, emptyMessageCallToAction: emptyMessageCallToAction, filterText: filterText, source: source, filter: filter })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, loading === (0, $ctLrB.LoadingState).done && pageCardDataLength === 0 && !hasNextPage && !error ? filterText !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2e32c2416bb0a42b$export$ef6006467f04ee41), {
        message: noResultsMessage,
        subMessage: noResultsSubtext,
        filterText: filterText,
        source: source,
        filter: filter
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $10e3f67db57b52fe$export$1f74963c34e8bfec), {
        header: emptyMessageHeader,
        body: emptyMessageBody,
        image: emptyMessageImage,
        callToAction: emptyMessageCallToAction
    }) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edxGF.Error), null)) : null), loading === (0, $ctLrB.LoadingState).initial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_lcxvglyw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1e0c1txw _1dth1h6o _4cvr1h6o _nr311h6o _1bah1h6o _tzy4105o"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154iuuw1 _1ltv1ssb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        testId: "view-loading"
    }))), hasNextPage && (filterText !== '' || pageCardDataLength !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLinG.ViewportObserver), {
        onViewportEnter: loadMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: {
            position: 'absolute',
            bottom: '0',
            height: '300px'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pkxy5q _4t3it9kd _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        testId: "page-loading"
    }))));
};
module.exports["LoadingAndPagination"] = $0efe97bbc4ecdd1c$export$2a05df71362b48c6;

});

parcelRegister("2HiJn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ln0hx = parcelRequire("ln0hx");

var $hjygH = parcelRequire("hjygH");


var $ctLrB = parcelRequire("ctLrB");

const $3cb714216690befb$export$4d0d88e71115d042 = ({ experienceName: experienceName, loading: loading, error: error, attributes: attributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: experienceName
    }), loading === (0, $ctLrB.LoadingState).done && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: experienceName,
        error: error,
        attributes: attributes
    }));
};
module.exports["ExperienceTracking"] = $3cb714216690befb$export$4d0d88e71115d042;

});

parcelRegister("7tW57", function(module, exports) {
var $2151245063608b19$export$fbac647384aa1326 = /*#__PURE__*/ function(QuickActionsEnum) {
    QuickActionsEnum["ShareButton"] = "SHARE";
    QuickActionsEnum["WatchButton"] = "WATCH";
    return QuickActionsEnum;
}({});
module.exports["QuickActionsEnum"] = $2151245063608b19$export$fbac647384aa1326;

});

parcelRegister("3DMri", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::04de3589381f9a0610e28dee990a4306>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a6a96a273f601bc$var$_react = $2a6a96a273f601bc$var$_interopRequireDefault((parcelRequire("42omo")));

var $2a6a96a273f601bc$var$_baseNew = $2a6a96a273f601bc$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2a6a96a273f601bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Adding items to your playlist (feature).
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a6a96a273f601bc$var$PlaylistAddIcon = (props)=>/*#__PURE__*/ $2a6a96a273f601bc$var$_react.default.createElement($2a6a96a273f601bc$var$_baseNew.default, Object.assign({
        name: "PlaylistAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.75 7v2.25H13v1.5h-2.25V13h-1.5v-2.25H7v-1.5h2.25V7z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$2a6a96a273f601bc$var$PlaylistAddIcon.displayName = 'PlaylistAddIcon';
var $2a6a96a273f601bc$var$_default = module.exports.default = $2a6a96a273f601bc$var$PlaylistAddIcon;

});

parcelRegister("lkdqP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03e629e0c059fb7914069e0530221781>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f865e27f7ba4cc3d$var$_react = $f865e27f7ba4cc3d$var$_interopRequireDefault((parcelRequire("42omo")));

var $f865e27f7ba4cc3d$var$_baseNew = $f865e27f7ba4cc3d$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f865e27f7ba4cc3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Indicating when things have been added to your playlist (feature)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f865e27f7ba4cc3d$var$PlaylistAddedIcon = (props)=>/*#__PURE__*/ $f865e27f7ba4cc3d$var$_react.default.createElement($f865e27f7ba4cc3d$var$_baseNew.default, Object.assign({
        name: "PlaylistAddedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.32 8.238-3.75 4.375a.75.75 0 0 1-1.162-.027l-1.75-2.25 1.184-.922 1.185 1.526 3.154-3.678z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$f865e27f7ba4cc3d$var$PlaylistAddedIcon.displayName = 'PlaylistAddedIcon';
var $f865e27f7ba4cc3d$var$_default = module.exports.default = $f865e27f7ba4cc3d$var$PlaylistAddedIcon;

});

parcelRegister("2Ihtu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b025e88f545a176f0bf73d94d1b7152>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f9d3eefac3e5dca$var$_react = $1f9d3eefac3e5dca$var$_interopRequireDefault((parcelRequire("42omo")));

var $1f9d3eefac3e5dca$var$_baseNew = $1f9d3eefac3e5dca$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1f9d3eefac3e5dca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PlaylistRemove".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Represents the action for removing things from the playlist feature.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f9d3eefac3e5dca$var$PlaylistRemoveIcon = (props)=>/*#__PURE__*/ $1f9d3eefac3e5dca$var$_react.default.createElement($1f9d3eefac3e5dca$var$_baseNew.default, Object.assign({
        name: "PlaylistRemoveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 8.28-1.72 1.719 1.72 1.72-1.06 1.06L10 11.06l-1.72 1.72-1.06-1.06L8.94 10 7.22 8.28l1.06-1.06L10 8.939l1.72-1.72z"/><path fill="currentcolor" d="M3.999 6.624A2.626 2.626 0 0 1 6.624 4h4.053l-.341-1.6a1.124 1.124 0 0 0-1.334-.866L2.399 2.937a1.124 1.124 0 0 0-.866 1.334l1.403 6.602c.11.517.558.873 1.063.889zm1.5 6.75c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.503 1.125-1.125v-6.75c0-.62-.504-1.125-1.125-1.125h-6.75c-.621 0-1.125.504-1.125 1.125zm10.5 0A2.625 2.625 0 0 1 13.374 16h-6.75a2.625 2.625 0 0 1-2.625-2.625v-.112a2.624 2.624 0 0 1-2.53-2.077L.064 4.582A2.626 2.626 0 0 1 2.088 1.47L8.689.066a2.626 2.626 0 0 1 3.114 2.022L12.21 4h1.164a2.625 2.625 0 0 1 2.625 2.625z"/>`
    }, props));
$1f9d3eefac3e5dca$var$PlaylistRemoveIcon.displayName = 'PlaylistRemoveIcon';
var $1f9d3eefac3e5dca$var$_default = module.exports.default = $1f9d3eefac3e5dca$var$PlaylistRemoveIcon;

});

parcelRegister("fROKr", function(module, exports) {
/* StatusLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $AXitC = parcelRequire("AXitC");

const $a2dbea423c2ae9ef$var$i18n = (0, $cgtv4.defineMessages)({
    unpublished: {
        id: "page-card.lozenge.unpublished",
        defaultMessage: "unpublished changes"
    },
    draft: {
        id: "page-card.lozenge.draft",
        defaultMessage: "draft"
    }
});
const $a2dbea423c2ae9ef$var$columnSpacingStyles = null;
const $a2dbea423c2ae9ef$export$f72db4ad1e9b3e6d = ({ isInColumn: isInColumn })=>{
    const { status: status } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const isValidStatus = status && !!$a2dbea423c2ae9ef$var$i18n[status];
    return isValidStatus ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isInColumn && "_19pkpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a2dbea423c2ae9ef$var$i18n[status]))) : null;
};
module.exports["StatusLozenge"] = $a2dbea423c2ae9ef$export$f72db4ad1e9b3e6d;

});

parcelRegister("4xawV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b73fd81dd104d571$export$38392c04ead71adc = (0, $42omo.createContext)({
    width: 0
});
module.exports["PageCardsContext"] = $b73fd81dd104d571$export$38392c04ead71adc;

});

parcelRegister("gETnG", function(module, exports) {
/* Excerpt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $li6DS = parcelRequire("li6DS");


var $5xvJl = parcelRequire("5xvJl");


var $AXitC = parcelRequire("AXitC");


var $4xawV = parcelRequire("4xawV");

const $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT = 14;
const $3fc611f28292b239$var$DEFAULT_NUMBER_OF_LINES = 3;
const $3fc611f28292b239$var$styles = {
    container: "_16jlcs5v _1o9zidpf _i0dl1wug _11c81o8v _slp31hna _19pkpxbi",
    text: "_1reo15vq _18m915vq _1e0ccj1k _1yyjcs5v _sudp1e54"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3fc611f28292b239$var$FlexibleText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { outerExcerptHeight: outerExcerptHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1f3fu42": (0, $7sObp.default)(Math.floor(__cmplp.outerExcerptHeight / $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0ccj1k _1yyj10m5 _sudp1e54",
            __cmplp.className
        ])
    });
});
const $3fc611f28292b239$export$470ad4730dc14be0 = ()=>{
    const { width: width } = (0, $42omo.useContext)((0, $4xawV.PageCardsContext));
    const { id: id, excerpt: excerpt } = (0, $42omo.useContext)((0, $AXitC.PageCardContext));
    const DEFAULT_EXCERPT_HEIGHT = $3fc611f28292b239$var$EXCERPT_LINE_HEIGHT * $3fc611f28292b239$var$DEFAULT_NUMBER_OF_LINES;
    const { ref: outerExcerptRef, height: outerExcerptHeight } = (0, $5xvJl.useHeightRef)(DEFAULT_EXCERPT_HEIGHT);
    return excerpt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        key: `${id}-${width}`,
        ref: outerExcerptRef,
        className: (0, $gMc0m.default)([
            $3fc611f28292b239$var$styles.container
        ])
    }, (0, $li6DS.getIsActivityV3RecentsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $3fc611f28292b239$var$styles.text
        ])
    }, excerpt) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3fc611f28292b239$var$FlexibleText, {
        outerExcerptHeight: outerExcerptHeight
    }, excerpt)) : null;
};
module.exports["Excerpt"] = $3fc611f28292b239$export$470ad4730dc14be0;

});

parcelRegister("5xvJl", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0dca7ed22d181ab5$export$5b067724590b37a4 = (defaultHeight = 0)=>{
    const [height, setHeight] = (0, $42omo.useState)(defaultHeight);
    const ref = (0, $42omo.useCallback)((node)=>{
        node && setHeight(node.clientHeight);
    }, []);
    return {
        height: height,
        ref: ref
    };
};
module.exports["useHeightRef"] = $0dca7ed22d181ab5$export$5b067724590b37a4;

});


$parcel$global.rlb("ghOf5")
//# sourceMappingURL=EndOfPageRecommendation.19dbfee6.js.map
